import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';

import { OSWidget } from './osWidget.jsx'
import { statusColors } from "../common/utils.js";
import { ResponsivePie } from "@nivo/pie";
import { fmCompactNum, fmDate, fmNum } from "../common/formatter.jsx";
import { ToastContainer, toast } from 'react-toastify';
import { ShowAlerts } from '../bmt/backlog.jsx';

import spinning_small from '../assets/images/spinning_small.gif';

//svg icons
import { WeChatIcon, LineIcon, MobileIcon } from '../common/icons.jsx';

import {
  exportExcelMaxLimit, BasicAlert, TabBar, Tab, showAllOrdersMaxLimit, ModalWidgetWaiting,
  Loading, MassDLInvoiceModal
} from '../common/components.jsx';

import * as OSWidgetLib from '../common/osWidgetLib.js';
import { DownloadTableAsShownXLSX } from '../common/DownloadTableAsShownXLSX.js';

//OSS StyleSheets
import '../assets/css/q2cui_oss.css';
import '../assets/css/oswidget.css';
import './widget-style.css';

//--slickgrid js
//import '../vendors/slickgrid/lib/jquery-1.11.2.min.js';
import '../vendors/slickgrid/lib/jquery.event.drag-2.3.0.js';
import '../vendors/slickgrid/lib/jquery-ui-1.12.1.custom.min.js';
import '../vendors/slickgrid/slick.core.js';
import '../vendors/slickgrid/slick.grid.js';
import '../vendors/slickgrid/plugins/slick.autotooltips.js';
import '../vendors/slickgrid/controls/slick.columnpicker.js';
import '../vendors/slickgrid/slick.colfix.js';
//--slickgrid css
import '../vendors/slickgrid/jquery-ui-1.11.3.oss.css';
import '../vendors/slickgrid/slick.grid_oss.css';
import '../vendors/slickgrid/slick-oss-theme.css';
import '../vendors/slickgrid/controls/slick.columnpicker.css';
import '../vendors/slistbox/listbox.css';

//JS Libs
var moment = require('moment');
import '../vendors/daterangepicker.js';
import '../assets/css/daterangepicker.css';

//Initial Definitions for legacy code
var subscreen = 'header';
var UserSettings = {};
var DrillDownData = null;
var DrillDownColumns = null;
var state;

if (typeof state == "undefined") {
  state = {}
}
state.fields = ["order_no", "purchase_order_no"];

var MainGrid = null;

//----------------------------------------------------------------------
//   WorkflowFormatter For DMFI
//
//----------------------------------------------------------------------

function WorkflowFormatter(row, cell, value, columnDef, dataContext) {

  var actionTitle = T('Your action is needed!');

  var dataIconWithAction = "<span>"
    + "<a onclick='return ShowOrderWidget(\"" + dataContext.legacy_order_no + "\");' style='float:left; cursor: pointer;'>"
    + T(value)
    + "</a>"
    + "<span title='\"" + actionTitle + "\"' style='background:#c1401a;padding:1px 5px 1px 5px;color:white;border-radius:5px;margin-left:2px'>"
    + "!"
    + "</span>"
    + "</span>";

  var dataIconNoAction = "<a onclick='return ShowOrderWidget(\"" + dataContext.legacy_order_no + "\");' style='float:left; cursor: pointer;'>"
    + T(value)
    + "</a>";


  if (UserSettings.isPartner) {
    switch (value) {
      case 'quote_cust_req':
      case 'quote_cust_app':
      case 'quote_cust_rej':
        return dataIconWithAction;
    }
  } else if (!UserSettings.isPartner) {
    if (value == 'quote_partner_prop')
      return dataIconWithAction;
  }

  return dataIconNoAction;
}

//----------------------------------------------------------------------
//   ItemStatusFormatter
//
//----------------------------------------------------------------------
function ItemStatusFormatter(row, cell, value, columnDef, dataContext) {

  return OSWidgetLib.mapItemStatus(value)

}

//----------------------------------------------------------------------
//   ESDFormatter
//
//----------------------------------------------------------------------
function ESDFormatter(row, cell, value, columnDef, dataContext) {

  if (dataContext.pdapi_no != undefined && dataContext.pdapi_no != "") {

    var url = "commhistajax.tcl?a0=getPDAPICommHistNewUI&a1=" + dataContext.pdapi_no_hash + "&a2=HPI"
    return "<a href=" + url + " target='_blank' style='float:left; cursor: pointer; color: #0096d6'>"
      + value
      + "</a>";

  } else {
    return value
  }

}

//----------------------------------------------------------------------
//   HPOrderNoFormatter
//
//----------------------------------------------------------------------
function HPOrderNoFormatter(row, cell, value, columnDef, dataContext) {
  return "<a onclick='return ShowOrderWidget(\"" + dataContext.legacy_order_no + "\");' style='float:left; cursor: pointer;'>"
    + value
    + "</a>";
}

//----------------------------------------------------------------------
//   InvoiceNoFormatter
//
//----------------------------------------------------------------------
function InvoiceNoFormatter(row, cell, value, columnDef, dataContext) {
  var url = RewriteRESTURL("/os/ossui/v1/ex/invoice?legacy_order_no=" + dataContext.legacy_order_no + "&invoice_no=" + dataContext.invoice_no + "&data_source=" + dataContext.om_system);
  var ret = "<a href=" + url + " target='_blank' style='float:left; cursor: pointer; color: #0096d6'>"
    + value
    + "</a>";

  // CR 15559 - deactivate invoice link for QAD
  if (dataContext.om_system == "QAD-IL" || dataContext.om_system == "QAD-JP" || dataContext.om_system == "QAD-NL" || dataContext.om_system == "QAD-US") {
    ret = dataContext.invoice_no;
  }

  return ret;
}

//----------------------------------------------------------------------
//   DateFormatter
//
//----------------------------------------------------------------------
function DateFormatter(row, cell, value, columnDef, dataContext) {
  if (columnDef.name == 'End Customer Planned Delivery Date'  && UserSettings.isPartner) {
    let tempValue = fmDate(value);
    if (tempValue) {
      const dateAftThreeDays = moment(tempValue, "DD MMM YYYY").add(3, 'days').format("DD MMM YYYY");
      const dateAftFourDays = moment(tempValue, "DD MMM YYYY").add(4, 'days').format("DD MMM YYYY");
      const dateAftFiveDays = moment(tempValue, "DD MMM YYYY").add(5, 'days').format("DD MMM YYYY");
      const dateAftSixDays = moment(tempValue, "DD MMM YYYY").add(6, 'days').format("DD MMM YYYY");
      const dateAftSevenDays = moment(tempValue, "DD MMM YYYY").add(7, 'days').format("DD MMM YYYY");
      const dateValue = moment(tempValue, "DD MMM YYYY").add(2, 'days');
      const current = moment().startOf('day');
      if (current.isSameOrAfter(dateValue, 'day')) {
        columnDef.width = 200;
        return (
          tempValue +
          ` <button style="margin-left:4px; padding: 1px 1px 1px" class="btn btn-xs btn-success" title=" Change to ${dateAftThreeDays}" onclick="window.addDays('${value}', 3, '${dataContext.legacy_order_no}')">+3</button>` +
          ` <button style="margin-left:2px; padding: 1px 1px 1px" class="btn btn-xs btn-info" title=" Change to ${dateAftFourDays}" onclick="window.addDays('${value}', 4, '${dataContext.legacy_order_no}')">+4</button>` +
          ` <button style="margin-left:2px; padding: 1px 1px 1px" class="btn btn-xs btn-warning" title=" Change to ${dateAftFiveDays}" onclick="window.addDays('${value}', 5, '${dataContext.legacy_order_no}')">+5</button>` +
          ` <button style="margin-left:2px; padding: 1px 1px 1px" class="btn btn-xs btn-primary" title=" Change to ${dateAftSixDays}" onclick="window.addDays('${value}', 6, '${dataContext.legacy_order_no}')">+6</button>` +
          ` <button style="margin-left:2px; padding: 1px 1px 1px" class="btn btn-xs btn-danger" title=" Change to ${dateAftSevenDays}" onclick="window.addDays('${value}', 7, '${dataContext.legacy_order_no}')">+7</button>`
        );
      }
    }
  }
  return fmDate(value);
}

window.addDays = function(dateString, daysToAdd, legacy_order_no) {
  let date = moment(dateString, "YYYY-MM-DD");
  if (!date.isValid()) {
    alert("Invalid date format");
    return;
  }
  let newDateString = date.add(daysToAdd, 'days').format("YYYY-MM-DD");
  let params = {
    legacy_order_no: legacy_order_no,
    new_date: newDateString
  };
  POST("/os/ossui/v1/ex/updatePODDate", params, function (result) {
    if (result.status === 'success') {
      toast.success(`Date updated to ${fmDate(newDateString)}`);
      setTimeout(() => {
        window.myLastOrdersInstance.drillDMFI("dmfiShipped", "all")();
      }, 3000);
    } else {
      toast.error(`Failed to update date: ${result.message}`);
    }
  });
  console.log(`New date after adding ${daysToAdd} days: ${newDateString}`);
}

//----------------------------------------------------------------------
//   AmountFormatter
//
//----------------------------------------------------------------------
function AmountFormatter(row, cell, value, columnDef, dataContext) {
  return fmNum(value);
}

function highlightBucket(bucket, range) {

  ["lastOrdersViewed", "lastOrdersPlaced", "lasstOrdersShipped",
    "submitOrders", "submittedOrders", "acceptedOrders",
    "productionOrders", "shippedOrders", "deliveredOrders",
    "shipmentCanceledOrders", "cancelledOrders"
  ].map(function (id) {
    $('#' + id).css({ background: "#767676" });
    $('#valCell_' + id).css({ background: "#ffffff" });
    $('#valCell_TradeOrder' + id).css({ background: "#ffffff" });
    $('#valCell_ClaimOrder' + id).css({ background: "#ffffff" });
    $('#valCell_ContractOrder' + id).css({ background: "#ffffff" });
  });

  if (bucket === 'Trade Order' || bucket === 'Claim Order' || bucket === 'Contract Order') {
    if (range.toLowerCase() === 'processing') range = 'accepted';
    if (range.toLowerCase() === 'submitted') range = 'submit';
    if (range.toLowerCase() === 'canceled') range = 'cancelled';
    if (range.toLowerCase() === 'total') range = 'submitted';
    let firstBucket = range.toLowerCase();
    firstBucket = firstBucket + 'Orders';

    let secondBucket = bucket.replace(/ +/g, '');
    secondBucket = secondBucket + firstBucket;

    $("#" + firstBucket).css({
      background: "#0096d6"
    });
    $("#valCell_" + secondBucket).css({
      background: "#eeeeee"
    });
  } else {
    $("#" + bucket).css({
      background: "#0096d6"
    });
    $("#valCell_" + bucket).css({
      background: "#eeeeee"
    });
  }
}

//----------------------------------------------------------------------
//   GridSorter
//
//----------------------------------------------------------------------
function GridSorter() {

  var cols = MainGrid.getSortColumns();

  var l = cols.length

  for (var i = 0; i < l; i++) {

    var field = cols[i].columnId;

    var isNum = true;
    DrillDownData.sort(function (row) {

      if (row[field] == null) {
        isNum = false;
      } else
        if (row[field].order) {
          isNum = false;
        } else
          if (typeof row[field] == "number") {
          } else
            if (!row[field].match(/^-?[£$¤]?[\d,.]+%?$/)) {
              isNum = false;
            }
    });

    cols[i].isNum = isNum;
    //console.log(i, isNum); 
  }

  DrillDownData.sort(function (dataRow1, dataRow2) {
    for (var i = 0; i < l; i++) {
      var field = cols[i].columnId;
      var sign = cols[i].sortAsc ? 1 : -1;

      var value1 = dataRow1[field];
      if (value1.order) {
        value1 = value1.order;
      }
      var value2 = dataRow2[field];
      if (value2.order) {
        value2 = value2.order;
      }
      if (cols[i].isNum) {
        if (typeof value1 == "string") {
          var aa = parseFloat(value1.replace(/[^0-9.-]/g, ''));
          if (isNaN(aa)) aa = 0;
        } else {
          aa = value1;
        }
        if (typeof value2 == "string") {
          var bb = parseFloat(value2.replace(/[^0-9.-]/g, ''));
          if (isNaN(bb)) bb = 0;
        } else {
          bb = value2;
        }
        var result = (aa == bb ? 0 : (aa > bb ? 1 : -1)) * sign;
      } else {
        var result = (value1 == value2 ? 0 : (value1 > value2 ? 1 : -1)) * sign;
      }
      if (result != 0) {
        return result;
      }
    }
    return 0;
  });

  MainGrid.invalidate();
  MainGrid.render();
}


//----------------------------------------------------------------------
//   UpdateUserSettings
//
//----------------------------------------------------------------------
function UpdateUserSettings(next) {
  var usersettings = {
    settings: {
      order: UserSettings.fields.order.choosen.join(" "),
      item: UserSettings.fields.item.choosen.join(" "),
      mfg: UserSettings.fields.mfg.choosen.join(" "),
      cp: UserSettings.fields.cp.choosen.join(" "),
      orderLevelOutputmode: UserSettings.fields.order.orderLevelOutputmode,
      itemLevelExactMatch: UserSettings.fields.order.itemLevelExactMatch,
      orderTypeOutputmode: UserSettings.fields.order.orderTypeOutputmode,
    }
  }
  console.log('usersettings=', usersettings);

  POST('/os/ossui/v1/ex/usersettings', usersettings, function (response) {
    return next(null, response);
  });
}


//----------------------------------------------------------------------
//   jQuery highlight
//
//----------------------------------------------------------------------
jQuery.fn.highlight = function (str, className) {
  var regex = new RegExp(str, "gi");
  return this.each(function () {
    $(this).contents().filter(function () {
      return this.nodeType == 3 && regex.test(this.nodeValue);
    }).replaceWith(function () {
      return (this.nodeValue || "").replace(regex, function (match) {
        return "<span class=\"" + className + "\">" + match + "</span>";
      });
    });
  });
};


/*----------------------------------------------------------------------------
|   MoreInfoModal
|
\---------------------------------------------------------------------------*/
class MoreInfoModal extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    var notification = this.props.notification;
    var channelIcon = null;

    if (notification.channel == 'WeChat') channelIcon = <WeChatIcon className="notifications-channel-icon-color" />;
    else if (notification.channel == 'Line') channelIcon = <LineIcon className="notifications-channel-icon-color" />;
    else channelIcon = <MobileIcon className="notifications-channel-icon-color" />;

    return (
      <div className="modal" data-backdrop="static" id="notificationInfoModal" style={{ "display": "block" }}>
        <div className="modal-dialog modal-lg" style={{ "width": "600px", "marginTop": "160px" }}>
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal" aria-hidden="true" onClick={this.props.handleClose}>x</button>
              <h3 className="modal-title">
                <span className="nt-title"><a onClick={this.props.handleLink}>{notification.order_no}</a></span>
                <span className='date' style={{ 'marginRight': '20px', 'float': 'right' }}>Date: {fmDate(notification.trigger_timestamp)}</span>
              </h3>
            </div>
            <div className="modal-body">
              <div className="nt-channel" style={{ 'marginBottom': '15px', 'justifyContent': 'space-between', 'fontSize': '16px' }}>
                <span style={{ 'fontWeight': '400' }}>Trigger: {notification.trigger_type}</span>
                <span style={{ 'color': '#0096d6' }}>{channelIcon}</span>
              </div>
              <div style={{ 'fontWeight': 'lighter' }} dangerouslySetInnerHTML={{ __html: notification.content }} />
            </div>
            <div className="modal-footer">
              <a data-dismiss="modal" className="nt-close btn-primary" onClick={this.props.handleClose}>Close</a>
            </div>
          </div>
        </div>
      </div>
    );
  }

}

//----------------------------------------------------------------------
//   Show Notifications
//
//----------------------------------------------------------------------
class Notifications extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showMoreInfoModal: false,
      showWidgetInfoModal: false,
      order: {},
      moreNotification: {}
    }
    this.handleShowMore = this.handleShowMore.bind(this);
    this.handleHideModal = this.handleHideModal.bind(this);
    this.handleShowWidget = this.handleShowWidget.bind(this);
    this.handleExtWidgetLink = this.handleExtWidgetLink.bind(this);
  }

  handleShowMore(notification) {
    this.setState({ showMoreInfoModal: true, moreNotification: notification })
  }

  handleHideModal() {
    this.setState({ showMoreInfoModal: false, moreNotification: {} })
  }

  async handleShowWidget(lookupValue, orderNo) {
    var orderData = {};
    this.setState({ showWidgetInfoModal: true, showMoreInfoModal: false, order: orderData })

    const response = await fetch("/os/ossui/v1/ex/widget/order?lookupType=legacy_order_no&lookupValue=" + lookupValue + "&os_no=" + orderNo, { method: 'GET', headers: { 'Content-Type': 'application/json' } });
    const result = await response.json();

    if (result.status === 'S') {
      this.setState({ order: result.data })
      window.setTimeout(() => {
        $('#ossOrderModal').modal({ backdrop: 'static' });
      }, 20)
    } else {
      alert(result.message)
    }
  }

  handleExtWidgetLink() {
    let orderNo = this.state.moreNotification.order_no;
    let lookupValue = this.state.moreNotification.qtcuid;
    this.handleHideModal()
    this.handleShowWidget(lookupValue, orderNo)
  }

  render() {
    let data = this.props.data;
    let notificationSize = data.length;
    var moreInfoModal = null;
    var widgetInfoModal = null;

    if (this.state.showMoreInfoModal) {
      moreInfoModal = <MoreInfoModal notification={this.state.moreNotification} handleLink={this.handleExtWidgetLink} handleClose={this.handleHideModal} />
    }

    if (this.state.showWidgetInfoModal) {
      widgetInfoModal = this.state.order.order_no ? <OSWidget order={this.state.order} /> : null
    }

    return (
      <div className='notification-section'>
        <div className='head'>{notificationSize} notification(s) from past week</div>
        <div className='content'>
          {data.length > 0 ? (
            data.map((notification, i) => {
              var channelIcon = null;

              if (notification.channel == 'WeChat') channelIcon = <WeChatIcon className="notifications-channel-icon-color" />;
              else if (notification.channel == 'Line') channelIcon = <LineIcon className="notifications-channel-icon-color" />;
              else channelIcon = <MobileIcon className="notifications-channel-icon-color" />;

              return (
                <div className="nt-item" key={i}>
                  <div className="nt-top">
                    <span className="nt-title"><a onClick={() => this.handleShowWidget(notification.qtcuid, notification.order_no)}>{notification.order_no}</a></span>
                    <span className='date'>Date: {fmDate(notification.trigger_timestamp)}</span>
                  </div>
                  <div className="nt-middle">
                    <span className="nt-channel">
                      <span style={{ 'marginRight': '10px' }}>Trigger: {notification.trigger_type}</span>
                      <span style={{ 'color': '#0096d6' }}>{channelIcon}</span>
                    </span>
                    <span className="show-more" onClick={() => this.handleShowMore(notification)}>More</span>
                  </div>
                </div>
              )
            })
          ) : <span>You don't have any notifications right now</span>
          }
        </div>
        {moreInfoModal}
        {widgetInfoModal}
      </div>
    )
  }
}

//------------------------------------------------------------------------
//  CustomizeFieldsDialog
//
//-----------------------------------------------------------------------
class CustomizeFieldsDialog extends React.Component {

  constructor(props) {
    super(props);
    this.handleCustomizeColumnsSave = this.handleCustomizeColumnsSave.bind(this);
    this.handleCustomizeColumnsCancel = this.handleCustomizeColumnsCancel.bind(this);
    this.colSelectorUp = this.colSelectorUp.bind(this);
    this.colSelectorDown = this.colSelectorDown.bind(this);
    this.colSelectorAdd = this.colSelectorAdd.bind(this);
    this.colSelectorRemove = this.colSelectorRemove.bind(this);
    this.colSelectorStd = this.colSelectorStd.bind(this);
  }

  handleCustomizeColumnsSave() {
    console.log('handleCustomizeColumnsSave:');

    var selectedNode = ReactDOM.findDOMNode(this.refs.selectedColumnList);
    var selOptions = selectedNode && selectedNode.options;

    var selected = [];
    for (var i = 0; i < selOptions.length; i++) {
      selected.push(selOptions[i].value + "");
    }
    console.log(selected);
    if (selected.length == 0) {
      selected.push('HPOrderNo');
    }
    console.log('selected field=', selected);
    if (this.props.subscreen == 'header') {
      UserSettings.fields.order.choosen = selected;
    } else if (this.props.subscreen == 'item') {
      UserSettings.fields.item.choosen = selected;
    } else if (this.props.subscreen == 'detail') {
      UserSettings.fields.mfg.choosen = selected;
    } else if (this.props.subscreen == 'cp') {
      UserSettings.fields.cp.choosen = selected;
    } else {
      console.log("error: no valid subscreen");
    }
    UpdateUserSettings(function (err, resp) {
      console.log('user setting written:', err, resp);
    });

    //ToDo GEGA, do something to rerender and apply the view
    //this.setState(this.state);

    var customizeAreaNode = ReactDOM.findDOMNode(this).parentNode;
    ReactDOM.unmountComponentAtNode(customizeAreaNode);
    $('.modal-backdrop').remove();
    $('.modal-open').removeClass('modal-open');
    //$('#ossCustomizeGridModal').modal('hide');
    //$('#customizeArea').empty();
  }

  handleCustomizeColumnsCancel() {

    var customizeAreaNode = ReactDOM.findDOMNode(this).parentNode;
    ReactDOM.unmountComponentAtNode(customizeAreaNode);
    $('.modal-backdrop').remove();
    $('.modal-open').removeClass('modal-open');
    //$('#ossCustomizeGridModal').modal('hide');
    //$('#customizeArea').empty();   
  }

  colSelectorUp() {

    console.log('colSelectorUp');

    var selectedNode = ReactDOM.findDOMNode(this.refs.selectedColumnList);
    var selOptions = selectedNode && selectedNode.options;

    var selected = [];
    for (var i = 0, iLen = selOptions.length; i < iLen; i++) {
      if (selOptions[i].selected) {
        selected.push(selOptions[i]);
      }
    }

    for (i = 0, iLen = selected.length; i < iLen; i++) {
      var index = selected[i].index;

      var temp = selected[i].text;
      selected[i].text = selOptions[index - 1].text;
      selOptions[index - 1].text = temp;

      temp = selected[i].value;
      selected[i].value = selOptions[index - 1].value;
      selOptions[index - 1].value = temp;

      selected[i].selected = false;
      selOptions[index - 1].selected = true;
    }
  }

  colSelectorDown() {

    console.log('colSelectorDown');

    var selectedNode = ReactDOM.findDOMNode(this.refs.selectedColumnList);
    var selOptions = selectedNode && selectedNode.options;

    var selected = [];
    for (var i = 0, iLen = selOptions.length; i < iLen; i++) {
      if (selOptions[i].selected) {
        selected.push(selOptions[i]);
      }
    }

    for (i = selected.length - 1, iLen = 0; i >= iLen; i--) {
      var index = selected[i].index;

      if (index == (selOptions.length - 1)) {
        break;
      }

      var temp = selected[i].text;
      selected[i].text = selOptions[index + 1].text;
      selOptions[index + 1].text = temp;

      temp = selected[i].value;
      selected[i].value = selOptions[index + 1].value;
      selOptions[index + 1].value = temp;

      selected[i].selected = false;
      selOptions[index + 1].selected = true;
    }
  }

  makeDisabled(sel, avl) {

    for (var j = 0; j < avl.length; j++) {
      avl[j].disabled = false;
    }

    for (var i = 0; i < sel.length; i++) {
      for (var j = 0; j < avl.length; j++) {
        if (sel[i].value == avl[j].value) {
          avl[j].disabled = true;
        }
      }
    }
  }

  colSelectorAdd() {

    console.log('colSelectorAdd', this);

    var availableNode = ReactDOM.findDOMNode(this.refs.availableColumnList);
    var selectedNode = ReactDOM.findDOMNode(this.refs.selectedColumnList);
    var avlOptions = availableNode && availableNode.options;
    var selOptions = selectedNode && selectedNode.options;

    for (var i = 0; i < avlOptions.length; i++) {
      var opt = avlOptions[i];
      if (opt.selected) {
        opt.selected = false;
        var found = false;
        for (var j = 0; j < selOptions.length; j++) {
          if (selOptions[j].value == opt.value) {
            found = true;
          }
        }
        // prevent re-adding multiple times
        if (!found) {
          var nopt = document.createElement("option");
          nopt.text = opt.text;
          nopt.value = opt.value;
          selectedNode.add(nopt);
        }
      }
    }
    this.makeDisabled(selOptions, avlOptions);
  }

  colSelectorRemove() {
    console.log('colSelectorRemove');
    var availableNode = ReactDOM.findDOMNode(this.refs.availableColumnList);
    var selectedNode = ReactDOM.findDOMNode(this.refs.selectedColumnList);
    var avlOptions = availableNode && availableNode.options;
    var selOptions = selectedNode && selectedNode.options;

    for (var i = selOptions.length - 1; i >= 0; i--) {
      var opt = selOptions[i];
      if (selOptions[i].selected) {
        selectedNode.remove(i);
      }
    }
    this.makeDisabled(selOptions, avlOptions);
  }

  colSelectorStd() {
    console.log('colSelectorStd');

    var availableNode = ReactDOM.findDOMNode(this.refs.availableColumnList);
    var selectedNode = ReactDOM.findDOMNode(this.refs.selectedColumnList);
    var stdNode = ReactDOM.findDOMNode(this.refs.standardColumnList);

    var avlOptions = availableNode && availableNode.options;
    var stdOptions = stdNode && stdNode.options;
    var selOptions = selectedNode && selectedNode.options;

    for (var i = selOptions.length - 1; i >= 0; i--) {
      selectedNode.remove(i);
    }
    for (var i = 0; i < stdOptions.length; i++) {
      var opt = stdOptions[i];
      var nopt = document.createElement("option");
      nopt.text = opt.text;
      nopt.value = opt.value;
      selOptions.add(nopt);
    }
    this.makeDisabled(selOptions, avlOptions);
  }

  componentWillUnmount() {
    console.log('CustomizeFieldsDialog unmount ...');
    $('#ossCustomizeGridModal').hide();
  }

  componentDidMount() {
    // console.log('CustomizeFieldsDialog mount ...');

    var availableNode = ReactDOM.findDOMNode(this.refs.availableColumnList);
    var selectedNode = ReactDOM.findDOMNode(this.refs.selectedColumnList);
    var standardNode = ReactDOM.findDOMNode(this.refs.standardColumnList);

    var avlOptions = availableNode && availableNode.options;
    var stdOptions = standardNode && standardNode.options;
    var selOptions = selectedNode && selectedNode.options;

    if (this.props.subscreen == 'header') {
      var settings = UserSettings.fields.order;
    } else if (this.props.subscreen == 'item') {
      var settings = UserSettings.fields.item;
    } else if (this.props.subscreen == 'detail') {
      var settings = UserSettings.fields.mfg;
    } else if (this.props.subscreen == 'cp') {
      var settings = UserSettings.fields.cp;
    } else {
      console.log("error: no valid subscreen");
    }

    for (var i = avlOptions.length; i >= 0; i--) {
      availableNode.remove(i);
    }
    for (var i = stdOptions.length; i >= 0; i--) {
      standardNode.remove(i);
    }
    for (var i = selOptions.length; i >= 0; i--) {
      selectedNode.remove(i);
    }

    settings.defaultFields.map(function (f, pos) {
      var opt = document.createElement("option");
      var txt = f;
      for (var i = 0; i < settings.all.length; i++) {
        if (settings.all[i].field == f) {
          txt = settings.all[i].name;
        }
      }
      opt.text = txt;
      opt.value = f;
      standardNode.add(opt);
    });

    settings.choosen.map(function (f, pos) {
      var opt = document.createElement("option");
      var txt = f;
      for (var i = 0; i < settings.all.length; i++) {
        if (settings.all[i].field == f) {
          txt = settings.all[i].name;
        }
      }
      opt.text = txt;
      opt.value = f;
      selectedNode.add(opt);
    });

    var avlFields = [];
    settings.all.map(function (f, pos) {
      avlFields.push(f.name);
    });
    avlFields.sort(function (a, b) {
      return (a == b) ? 0 : (a > b) ? 1 : -1;
    }).map(function (f, pos) {

      var opt = document.createElement("option");
      var val = f;
      for (var i = 0; i < settings.all.length; i++) {
        if (settings.all[i].name == f) {
          val = settings.all[i].field;
        }
      }
      opt.text = f;
      opt.value = val;
      availableNode.add(opt);
    });

    this.makeDisabled(selOptions, avlOptions);
    $('#ossCustomizeGridModal').modal({
      backdrop: 'static',
      keyboard: false
    });
  }

  render() {

    return (
      <div className="modal" id="ossCustomizeGridModal" data-keyboard="false">
        <div className="modal-dialog modal-lg" style={{ "width": "710px" }}>
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" aria-hidden="true" onClick={this.handleCustomizeColumnsCancel}  >x</button>
              <h3 className="modal-title">{T('Customize Columns')}</h3>
            </div>
            <div className="modal-body" style={{ "height": "460px", "overflow": "auto", "maxHeight": "460px" }}>
              <table style={{ "margin": "10px" }}>
                <tbody>
                  <tr>
                    <td style={{ "backgroundColor": "#777777", "color": "white", "padding": "2px 8px 2px 8px", "width": "30%", "whiteSpace": "nowrap" }}>{T('Standard Columns')}</td>
                    <td></td>
                    <td style={{ "backgroundColor": "#0096d6", "color": "white", "padding": "2px 8px 2px 8px", "width": "270px", "whiteSpace": "nowrap" }}>{T('Selected Columns')}</td>
                    <td></td>
                    <td style={{ "backgroundColor": "#777777", "color": "white", "padding": "2px 8px 2px 8px", "width": "270px", "whiteSpace": "nowrap" }}>{T('Available Columns')}</td>
                  </tr>
                  <tr>
                    <td>
                      <select multiple="1" size="20" ref="standardColumnList" id="standardColumnList" style={{ "width": "100%" }}>
                      </select>
                    </td>
                    <td align="center" style={{ "padding": "3px 3px 3px 6px", "maxWidth": "50px", "width": "50px" }}>
                      <button className="btn btn-primary" style={{ "padding": "2px 6px 6px 8px" }} onClick={this.colSelectorStd}  ><i className="glyphicon glyphicon-forward" /></button>
                    </td>
                    <td>
                      <select multiple="1" size="20" ref="selectedColumnList" id="selectedColumnList" style={{ "width": "100%", "boxShadow": "0px 4px 20px #999" }}>
                      </select>
                    </td>
                    <td align="center" style={{ "padding": "3px 0px 3px 6px", "maxWidth": "50px", "width": "50px", "textAlign": "center" }}>
                      <button className="btn btn-primary" style={{ "padding": "2px 8px 6px 8px" }} onClick={this.colSelectorUp}><i className="glyphicon glyphicon-arrow-up" /></button>
                      <br />
                      <br />
                      <button className="btn btn-primary" style={{ "padding": "2px 8px 6px 8px" }} onClick={this.colSelectorDown}><i className="glyphicon glyphicon-arrow-down" /></button>
                      <br />
                      <br />
                      <br />
                      <br />
                      <button className="btn btn-primary" style={{ "padding": "2px 8px 6px 8px" }} onClick={this.colSelectorAdd}><i className="glyphicon glyphicon-arrow-left" /></button>
                      <br />
                      <br />
                      <button className="btn btn-primary" style={{ "padding": "2px 8px 6px 8px" }} onClick={this.colSelectorRemove}><i className="glyphicon glyphicon-arrow-right" /></button>
                    </td>
                    <td>
                      <select multiple="1" size="20" ref="availableColumnList" id="availableColumnList" style={{ "width": "100%" }}>
                      </select>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div style={{ "padding": "7px", "width": "100%", "backgroundColor": "#0096d6", "boxShadow": "1px 3px 9px", "whiteSpace": "normal" }}>
                <div style={{ "color": "white" }}>
                  {T('In order to view the recently added columns click again on the same dashboard number value or on the Search button, new columns will be displayed across.')}
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" onClick={this.handleCustomizeColumnsSave} className="btn btn-primary">{T('Save')}</button>
              <button type="button" onClick={this.handleCustomizeColumnsCancel} className="btn btn-info">{T('Cancel')}</button>
            </div>
          </div>
        </div>
      </div>
    )
  }
};

//------------------------------------------------------------------------
//  RDataGrid    -   a data grid based on SlickGrid wrapped in a
//                   reactjs component
//
//------------------------------------------------------------------------
class RDataGrid extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      charWidth: this.props.charWidth,
      columns: this.props.columns,
      data: this.props.data,
      show: false,
      dmfiPending: this.props.dmfiPending,
      dmfiShipped: this.props.dmfiShipped
    };

    this.grid = null;
    this.customizeMenu = null;

    this._textWidth = this._textWidth.bind(this);
    this.handleCustomizeGrid = this.handleCustomizeGrid.bind(this);
    this.handleInvoiceMassDownload = this.handleInvoiceMassDownload.bind(this);
  }

  showModal = e => {
    this.setState({
      show: !this.state.show,
      type: e.target.name
    });
  };

  handleCustomizeGrid(e) {
    console.log('handleCustomizeGrid:', e);
    ReactDOM.render(<CustomizeFieldsDialog subscreen={this.props.subscreen} />, document.getElementById("customizeArea"));
  }

  handleInvoiceMassDownload(e) {
    console.log('handleInvoiceMassDownload:', e);
    //ReactDOM.render( <CustomizeFieldsDialog subscreen={this.props.subscreen} />, document.getElementById("customizeArea"));
  }

  componentWillUnmount() {
    console.log('CustomizeFieldsDialog unmount ...');
    $('#ossCustomizeGridModal').hide();
  }

  componentDidMount() {
  }

  _textWidth(txt) {
    var xw = this.charWidth['x'];
    var w = 0;
    if (!txt) {
      return (w + 6);
    }
    for (var i = 0, len = txt.length; i < len; i++) {
      var c = txt[i];
      if (this.charWidth[c]) {
        w += this.charWidth[c]
      } else {
        w += xw;
      }
    }
    //console.log('textWidth "'+txt+'" = ', w);
    return (w + 6);
  }

  componentWillUnmount() {
    //MainGrid = null;
  }

  componentDidMount() {
    if (this.props.id) {
      var id = '#' + this.props.id;

      if (this.props.embedInto) {
        var embedHeight = $(this.props.embedInto).height();
        var embedWidth = $(this.props.embedInto).width();
        $(id)
          .css("height", (embedHeight - 23) + 'px')
          .css("width", (embedWidth - 0) + 'px');
      }

      if (this.state.charWidth == null) {
        this.charWidth = {};
        var charList = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_-+=/?;:,.[]{}()!@#$%^&*";

        for (var i = 0, len = charList.length; i < len; i++) {
          var c = charList[i];
          var o = $('<div class="slick-cell" style="padding: 0px">' + c + '</div>').appendTo($(id));

          this.charWidth[c] = o.width();
          o.remove();
          //console.log( c, this.charWidth[c] );
        }
      }

      // data is passed as array or cell data (relational)
      var colLen = [];
      for (var j = 0; j < this.state.columns.length; j++) {
        colLen[j] = this._textWidth(this.state.columns[j].name) - 2;
      }

      if (this.props.compactData) {
        var rows = [];
        for (var i = 0; i < this.props.compactData.length; i++) {
          var row = {};
          for (var j = 0; j < this.props.compactData[i].length; j++) {

            row[this.state.columns[j].field] = this.props.compactData[i][j];
            var textWidth = this._textWidth(this.props.compactData[i][j]);
            if (textWidth > colLen[j]) {
              colLen[j] = textWidth;
            }
          }
          rows.push(row);
        }
        this.data = rows;

      } else {

        for (var i = 0; i < this.state.data.length; i++) {
          for (var j = 0; j < this.state.columns.length; j++) {
            var textWidth = 10 + this._textWidth(this.state.data[i][this.state.columns[j].field]);
            if (textWidth > colLen[j]) {
              colLen[j] = textWidth;
            }
          }
        }
      }
      //min widh for date fields?
      for (var j = 0; j < this.state.columns.length; j++) {
        let columns = Object.assign({}, this.state.columns);
        var maxWidth = columns[j].maxWidth ? columns[j].maxWidth : 150;
        if (columns[j].width > maxWidth) {
          columns[j].width = maxWidth;
        }
        this.setState({ columns });
      }
      this.forceUpdate();

      DrillDownData = this.state.data;
      DrillDownColumns = this.state.columns;

      this.grid = new Slick.Grid(id, this.state.data, this.state.columns, this.props.options);
      this.grid.registerPlugin(new Slick.AutoTooltips({ enableForHeaderCells: true }));
      var columnpicker = new Slick.Controls.ColumnPicker(this.state.columns, this.grid, this.props.options);
      var self = this;
      this.grid.onColumnsReordered.subscribe(function (e, args) {
        console.log('RDataGrid onColumnsReordered:', e, args);
        console.log(self.grid.getColumns());
        var newFields = [];
        self.grid.getColumns().forEach(function (f) {
          newFields.push(f.field + "");
        });
        console.log('newFields:', newFields);
        if (self.props.subscreen == 'header') {
          UserSettings.fields.order.choosen = newFields;
        } else if (self.props.subscreen == 'item') {
          UserSettings.fields.item.choosen = newFields;
        } else if (self.props.subscreen == 'detail') {
          UserSettings.fields.mfg.choosen = newFields;
        } else if (self.props.subscreen == 'cp') {
          UserSettings.fields.cp.choosen = newFields;
        } else {
          console.log("error: no valid subscreen");
        }
        UpdateUserSettings(function (err, resp) {
          console.log('user setting written:', err, resp);
        });
      });
      MainGrid = this.grid;
      this.grid.onSort.subscribe(GridSorter);

      this.grid.onDblClick.subscribe(function (e, args) {
        console.log('grid.onClick:', args);
        console.log(self.state.data[args.row]);
        self.props.onClick(self.state.data[args.row]);
        e.preventDefault();
      });

      state.setGridData = function (rows) {
        self.state.data = rows;
        DrillDownData = self.state.data;
        self.grid.invalidate();
        self.grid.render();
      }

      this.grid.resizeCanvas();
      this.grid.onViewportChanged.notify();

      if (state.sortCols) {
        this.grid.setSortColumns(state.sortCols);
        GridSorter();
      } else
        if (this.props.defaultSort) {
          var sortColumns = this.props.defaultSort.map(function (field) {
            return { columnId: field, sortAsc: true }
          });
          this.grid.setSortColumns(sortColumns);
          GridSorter();
        }
    } else {
      console.warn('RDataGrid needs an id to work.');
    }
  }

  componentDidUpdate() {
    this.grid.onViewportChanged.notify();
  }

  render() {
    var style = {
      position: 'relative',
      height: '400px',
      width: '400px'
    }

    if (this.props.embedInto) {
      var embedHeight = $(this.props.embedInto).height();
      var embedWidth = $(this.props.embedInto).width();
      style.height = (embedHeight - 23) + 'px';
      style.width = (embedWidth - 0) + 'px';

      $("#drilldowndata .slick-viewport").css( {
        width: '100.2%'
      });
    }

    var nrRows = null;

    if (this.props.compactData) {
      nrRows = this.props.compactData.length;
    } else {
      nrRows = this.state.data.length;
    }
    //console.log(this.props.nrOfRealRows);

    var warningTxt = null;
    if (this.props.nrOfRealRows && this.props.nrOfRealRows > 4000 && nrRows == 4000) {
      warningTxt = <span style={{ "backgroundColor": "#ff7777", "color": "#000000", "padding": "2px 5px 1px 5px", "marginLeft": "15px" }}> !! Only 4000 rows shown (out of {this.props.nrOfRealRows}) !! </span>;
    }

    var massDL = null;
    if (this.props.subscreen == "item") {

      massDL = <div className="btn-group navbar-right">Mass Download Options <a href="#" data-toggle="dropdown" className="dropdown-toggle">
        <i className="glyphicon glyphicon-circle-arrow-down" style={{ "color": "#fff" }} />
      </a>
        <ul className="dropdown-menu">
          <li><a onClick={this.showModal} style={{ color: '#333', cursor: 'pointer' }} title="mass download Invoice PDF" name="invoice-pdf"> mass download Invoice PDF <i className="glyphicon glyphicon-download-alt" /></a></li>
          <li><a onClick={this.showModal} style={{ color: '#333', cursor: 'pointer' }} title="mass download POD Docs" name="pod-docs"> mass download POD's <i className="glyphicon glyphicon-download-alt" /></a></li>
          <li><a onClick={this.showModal} style={{ color: '#333', cursor: 'pointer' }} title="mass download Packing Lists" name="packing-list"> mass download Packing List's <i className="glyphicon glyphicon-download-alt" /></a></li>
        </ul>
      </div>
    }
    var showFeature = true;
    if (this.props.dmfiPending == "Y")
      showFeature = false;

    return (
      <div style={{ padding: '0px', margin: '0px', float: 'left', width: '100%' }}>
        <div className="GridHeader">
          {showFeature && <div id="exports" style={{ "display": "flex", "justifyContent": "space-between" }}>
            <div id="exportToExcel">
              {this.props.exportToExcel}
            </div>
            <div id="massDL">
              {massDL}
            </div>
          </div>}
          <table border="0" width="100%">
            <tr>
              <td width='20%' style={{ color: 'white', 'textAlign': 'left' }}>
                {nrRows != null ? nrRows + ' rows' : ''}
                {warningTxt}
              </td>
              <td width='60%' style={{ color: 'white', 'fontStyle': 'italic', 'textAlign': 'center' }}>
                Drag and drop field to change column position, click on it to sort
              </td>
              {showFeature && <td width='20%' style={{ color: 'white', 'textAlign': 'right' }}>
                <a onClick={this.handleCustomizeGrid} style={{ color: 'white', cursor: 'pointer' }} title="customize displayed columns"><i className="glyphicon glyphicon-cog" /></a>
              </td>}
            </tr>
          </table>
        </div>
        <div id={this.props.id} style={style}>{this.props.id}</div>
        <MassDLInvoiceModal onClose={this.showModal} show={this.state.show} orders={this.props.data} type={this.state.type} />
        <ToastContainer position='bottom-right'/>
      </div>
    );
  }
};

RDataGrid.defaultProps = {
  id: null,
  charWidth: null,
  showCustomizeDlg: false,
  options: {   // SlickGrid options
    enableCellNavigation: false,
    enableColumnReorder: true,
    multiColumnSort: true,
    forceFitColumns: true,
    enableTextSelectionOnCells: true
  },
}

//----------------------------------------------------------------------
//   OSWidgetSearchWrapper -- shows search mask
//
//----------------------------------------------------------------------
class OSWidgetSearchWrapper extends React.Component {

  constructor(props) {
    super(props);
  }

  handleWarningMsg(details) {
    $("#resultMsg").html(details.message);
    $("#resultMsg").removeClass("info-alert");
    $("#resultMsg").addClass("alert alert-danger");
  }

  handleReset() {
    $("#resultMsg").html("");
    $("#resultMsg").removeClass("alert alert-danger info-alert");
  }

  validateSearchFields() {
    $("#resultMsg").html("");
    $("#resultMsg").removeClass("alert alert-danger info-alert");

    return true;
  }

  searchByHeader(searchParameters) {
    var params = {};
    var searchQry = {};
    var orderLevelOutputmode = UserSettings.fields.order.orderLevelOutputmode;
    var itemLevelExactMatch = UserSettings.fields.order.itemLevelExactMatch;
    var orderTypeOutputmode = UserSettings.fields.order.orderTypeOutputmode;

    if (orderLevelOutputmode == 'headerShow') {
      searchQry.searchBy = 'H'; // Header details search
    } else {
      searchQry.searchBy = 'I'; // Item details search            
    }

    searchQry.id = searchParameters.id;
    searchQry.id2 = searchParameters.id2;
    searchQry.id3 = searchParameters.id3;
    searchQry.searchField = searchParameters.searchField;
    searchQry.searchField2 = searchParameters.searchField2;
    searchQry.searchField3 = searchParameters.searchField3;
    searchQry.dateType = searchParameters.dateType;
    searchQry.dateTypeValue = searchParameters.dateTypeValue;
    searchQry.dateRange = searchParameters.dateRange;
    searchQry.orderType = orderTypeOutputmode;
    searchQry.itemExactMatch = itemLevelExactMatch;

    params.searchBy = searchQry.searchBy
    params.id = searchParameters.id;
    if (searchQry.id2 != "") {
      params.id2 = searchParameters.id2;
    }
    if (searchQry.id3 != "") {
      params.id3 = searchParameters.id3;
    }

    params.searchField = searchParameters.searchField;
    if (searchQry.searchField2 != "") {
      params.searchField2 = searchParameters.searchField2;
    }
    if (searchQry.searchField3 != "") {
      params.searchField3 = searchParameters.searchField3;
    }
    params.dateType = searchParameters.dateTypeValue;
    params.from = "";
    params.to = "";
    if (searchParameters.dateRange != "") {
      var dates = searchParameters.dateRange.split(/\s+/);   // why use spaces?? and not " to "  ??
      params.from = dates[0];
      params.to = dates[2];
    }
    params.orderType = searchQry.orderType;
    params.itemExactMatch = searchQry.itemExactMatch;

    // force grid to unmount, to later create fresh with data     
    ReactDOM.render(
      <OSLandingPage size={"large"} type={"searchresult"} hideGrid={true} searchQry={searchQry} />,
      document.getElementById('mainbody')
    );
    $("#resultMsg").html("");
    $("#resultMsg").removeClass("alert alert-danger info-alert");

    POST("/os/ossui/v1/ex/custSearch", params, function (result) {
      //alert(JSON.stringify(result));
      //console.log(JSON.stringify(result));
      //console.log(result.data);
      state.order = result;
      state.order.headerShow = result;
      state.searchQry = searchQry;
      $('#ossOrderModal').modal('hide');
      if (result.data.rows.length > 0) {
        if (result.data.rows.length == 1) {
          ShowOrderWidget(result.data.rows[0].legacy_order_no);
        }
        if (result.status == 'B') {
          var limitText = T('Only first 2000 orders are shown');
          if (searchQry.searchBy == "D") {
            var limitText = T('Only first 2000 rows are shown');
          }
          $("#resultMsgOrder").html(limitText);
          $("#resultMsgOrder").addClass("info-alert");//alert();
          $("#resultMsgOrder").show();
        } else {
          $("#resultMsgOrder").hide();
        }

        if (result.status == 'E') {
          var newMessage = (result.message instanceof Array && result.message.length == 3)
            ? T(result.message[0]) + result.message[1] + T(result.message[2])
            : T(result.message);
          $("#resultMsg").html(newMessage);
          $("#resultMsg").removeClass("info-alert");
          $("#resultMsg").addClass("alert alert-danger");
        } else {
          $("#resultMsg").html("");
          $("#resultMsg").removeClass("alert alert-danger info-alert");
        }
        ReactDOM.render(
          <OSLandingPage size={"large"} type={"searchresult"} subscreen={"header"} order={result} searchQry={searchQry} />,
          document.getElementById('mainbody')
        );

      } else {
        ReactDOM.render(
          <OSLandingPage size={"large"} type={"search"} order={"order"} searchQry={"searchQry"} />,
          document.getElementById('mainbody')
        );

        if (result.status == 'B') {
          var limitText = T('warn_search_exeed_more_than') + " 2000. " + T('warn_no_search_result') + ". " + T('warn_refine_search');
          if (searchQry.searchBy == "D") {
            limitText = T('warn_search_exeed_more_than') + " 2000. " + T('warn_no_search_result') + ". " + T('warn_refine_search');
          }
          $("#resultMsg").html(limitText);
          $("#resultMsg").removeClass("alert alert-danger");
          $("#resultMsg").addClass("info-alert");
        } else {
          if (result.message instanceof Array && result.message.length == 3) {
            var newMessage = T(result.message[0]) + result.message[1] + T(result.message[2]);
          } else {
            var newMessage = T(result.message);
          }
          $("#resultMsg").html(newMessage);
          $("#resultMsg").removeClass("info-alert");
          $("#resultMsg").addClass("alert alert-danger");
        }
      }
    });
  }

  searchByDetails(searchParameters) {
    var params = {};
    var searchQry = {};

    searchQry.searchBy = 'D'; // Detail details search
    searchQry.id = searchParameters.id;
    searchQry.searchField = searchParameters.searchField;
    searchQry.dateType = searchParameters.dateType;
    searchQry.dateTypeValue = searchParameters.dateTypeValue;
    searchQry.dateRange = searchParameters.dateRange;

    params.searchBy = searchQry.searchBy
    params.id = searchParameters.id.toUpperCase().replace(/^\s+|\s+$/g, '');
    params.searchField = searchParameters.searchField;
    params.dateType = searchParameters.dateTypeValue;
    params.from = "";
    params.to = "";
    if (searchParameters.dateRange != "") {
      var dates = searchParameters.dateRange.split(/\s+/);   // why use spaces?? and not " to "  ??
      params.from = dates[0];
      params.to = dates[2];
    }

    // force grid to unmount, to later create fresh with data
    ReactDOM.render(
      <OSLandingPage size={"large"} type={"searchresult"} hideGrid={true} searchQry={searchQry} />,
      document.getElementById('mainbody')
    );
    $("#resultMsg").html("");
    $("#resultMsg").removeClass("alert alert-danger info-alert");

    if (searchParameters.tabIndicator == 'CP') {
      params.searchBy = 'CP';
      searchQry.searchBy = 'CP';
    }

    POST("/os/ossui/v1/ex/mfgSearch", params, function (result) {
      //console.log("RESULT:");
      //console.log(JSON.stringify(result));
      //alert(JSON.stringify(result));
      //console.log(result.data);
      state.order = result;
      state.order.itemShow = result;
      state.searchQry = searchQry;

      if (params.searchBy == 'CP') {
        subscreen = 'cp';
      } else {
        subscreen = 'detail';
      }

      $('#ossOrderModal').modal('hide');

      if (result.data.rows.length > 0) {
        if (result.data.rows.length == 1 && params.searchBy != 'CP') {

          //console.log("result.data.rows[0].item_subitem[0]=====>"+result.data.rows[0].item_subitem[0]);
          // If the item data is returned then pass it over to ShowOrderWidget
          if (typeof result.data.rows[0].item_subitem !== 'undefined') {
            ShowOrderWidget(result.data.rows[0].legacy_order_no, result.data.rows[0].item_subitem[0]);
          } else {
            ShowOrderWidget(result.data.rows[0].legacy_order_no);
          }
        }
        if (result.status == 'B') {
          $("#resultMsgOrder").html(T("Only first 2000 orders are shown"));
          $("#resultMsgOrder").addClass("info-alert");//alert();
          $("#resultMsgOrder").show();
        } else {
          $("#resultMsgOrder").hide();
        }

        if (result.status == 'E') {
          var newMessage = (result.message instanceof Array && result.message.length == 3)
            ? T(result.message[0]) + result.message[1] + T(result.message[2])
            : T(result.message);
          $("#resultMsg").html(newMessage);
          $("#resultMsg").removeClass("info-alert");
          $("#resultMsg").addClass("alert alert-danger");
        } else {
          $("#resultMsg").html("");
          $("#resultMsg").removeClass("alert alert-danger info-alert");
        }

        ReactDOM.render(
          <OSLandingPage size={"large"} type={"searchresult"} subscreen={subscreen} order={result} searchQry={searchQry} />,
          document.getElementById('mainbody')
        );

      } else {

        ReactDOM.render(
          <OSLandingPage size={"large"} type={"search"} order={[]} searchQry={searchQry} />,
          document.getElementById('mainbody')
        );

        if (result.status == 'B') {
          var limitText = T("warn_search_exeed_more_than") + " 2000. " + T("warn_no_search_result") + ". " + T("warn_refine_search");
          if (params.searchBy == 'D') {
            limitText = T("warn_search_exeed_more_than") + " 2000. " + T("warn_no_search_result") + ". " + T("warn_refine_search");
          }
          $("#resultMsg").html(limitText);
          $("#resultMsg").removeClass("alert alert-danger");
          $("#resultMsg").addClass("info-alert");
        } else {
          if (result.message instanceof Array && result.message.length == 3) {
            var newMessage = T(result.message[0]) + result.message[1] + T(result.message[2]);
          } else {
            var newMessage = T(result.message);
          }

          $("#resultMsg").html(newMessage);
          $("#resultMsg").removeClass("info-alert");
          $("#resultMsg").addClass("alert alert-danger");
        }
      }
    });
  }

  closeErrorPane() {
    $("#errorPane").hide();
  }

  render() {

    var self = this;

    //GEGA WHY????????? THIS.STATE.SEARCHQRY != THIS.PROPS.SEARCHQRY !!!!
    //this.state.searchQry = this.props.searchQry;

    var searchQry = this.props.searchQry;

    // Blanking out strings if any
    if (typeof searchQry != 'object') {
      searchQry = {};
    }

    // Default search qry to header tab if not exists.
    searchQry = searchQry || { searchBy: 'H' };

    if (this.props.showOrder) {
      searchQry.id = this.props.showOrder;
    }

    //IF search by is blank then set to H
    if (!searchQry.searchBy ||
      (searchQry.searchBy != 'H' &&
        searchQry.searchBy != 'I' &&
        searchQry.searchBy != 'D')) {
      searchQry.searchBy = 'H'
    }
    var searchQryHeader = {};
    var searchQryDetails = {};

    // Default search qry to header tab if not exists.
    //this.props.searchQry.searchBy="D";
    //this.props.searchQry.id= "TTT!@";

    // Copy over fields
    if (searchQry && searchQry.searchBy && (searchQry.searchBy == 'H' || searchQry.searchBy == 'I')) {
      searchQryHeader = $.extend({}, searchQry);
    } else if (searchQry && searchQry.searchBy && searchQry.searchBy == 'D') {
      searchQryDetails = $.extend({}, searchQry);
    }

    // Define a SearchFieldMap
    var searchFieldMapH = {
      'quickSearch': T('Quick Search (single value)'),
      'cbn': T('HP Customer Number'),
      'customerPO': T('Customer PO'),
      'hpOrderNo': T('HP Order No'),
      'shipmentNo': T('Shipment No'),
      'trackingNo': T('Tracking No'),
      'invoiceNo': T('Invoice No'),
      'customerProduct': T('Customer Product'),
      'hpProduct': T('HP Product Number'),
      'customerName': T('Company Name'),
      'DealID': T('Deal Id'),
      'orderStatus': T('Status'),
      'quoteNo': T('Quote No'),
      'webOrderNo': T('Web Order No'),
      'eClaimNo': T('eClaim No'),
      'shipToAttnEmail': T('Ship To Attention Email')
    };

    // Define a SearchFieldMap for Mfg Search
    var searchFieldMapD = {
      'serialNo': T('Serial No'),
      'assetTag': T('Asset Tag'),
      'customerProduct': T('Customer Product'),
      'hpProduct': T('HP Product Number')
    };

    var searchFieldMapCP = {
      'hpOrderNo': T('HP Order No'),
      'customerPO': T('Customer PO'),
      'hpProduct': T('HP Product Number'),
      'rel_hw_serial_number': T('rel_hw_serial_number No'),
      'certificate_number': T('certificate_number'),
      'rel_hw_product_number' : T('rel_hw_product_number')
    };

    // Define a DateTypeMap
    var dateTypeMap = {
      'purchaseOrderDate': T('Purchase Order Date'),
      'hpReceiveDate': T('HP Receive Date'),
      'shippedDate': T('Ship Date'),
      'invoiceDate': T('Invoice Date')
    };

    var OrderSearchTabActive = false;
    if (searchQry.searchBy == "H" || searchQry.searchBy == "I") {
      OrderSearchTabActive = true;
    }

    var mfgSearchTabActive = false;
    if (searchQry.searchBy == "D") {
      mfgSearchTabActive = true;
    }

    var tabIndicator = this.props.tabIndicator;

    if (tabIndicator == "H") {
      return (
        <OSWidgetSearchTab tabData={{
          tabIndicator: 'H', // H = Header, D = Details
          blockTitle: T('Search your orders'),
          searchHint: T("searchHint"),
          searchQry: searchQryHeader,
          searchFieldMap: searchFieldMapH,
          searchField: "quickSearch",
          dateTypeMap: dateTypeMap,
          dateType: "purchaseOrderDate",
          showOrder: self.props.showOrder,
          orderLevelOutputmode: self.props.orderLevelOutputmode,
          itemLevelExactMatch: self.props.searchQry.itemExactMatch,
          orderTypeOutputmode: self.props.orderTypeOutputmode,
          type: self.props.type,
          bucket: searchQry.bucket
        }}
          handleReset={self.handleReset}
          validateSearchFields={self.validateSearchFields}
          handleWarningMsg={self.handleWarningMsg}
          handleSearch={self.searchByHeader} />
      );
    }

    if (tabIndicator == "D") {
      return (
        <OSWidgetSearchTab tabData={{
          tabIndicator: 'D',
          blockTitle: T('Search orders based on serialized products'),
          searchQry: searchQryDetails,
          searchFieldMap: searchFieldMapD,
          searchField: "serialNo",
          dateTypeMap: dateTypeMap,
          dateType: "purchaseOrderDate",
        }}
          handleReset={self.handleReset}
          validateSearchFields={self.validateSearchFields}
          handleWarningMsg={self.handleWarningMsg}
          handleSearch={self.searchByDetails} />
      );
    }

    if (tabIndicator == "CP") {

      dateTypeMap.service_start_date = T('service_start_date');
      dateTypeMap.service_end_date   = T('service_end_date');
      dateTypeMap.inactive_date      = T('inactive_date');

      return (
        <OSWidgetSearchTab tabData={{
          tabIndicator: 'CP',
          blockTitle: T('Search Services'),
          searchQry: searchQryDetails,
          searchFieldMap: searchFieldMapCP,
          searchField: "hpOrderNo",
          dateTypeMap: dateTypeMap,
          dateType: "purchaseOrderDate",
        }}
          handleReset={self.handleReset}
          validateSearchFields={self.validateSearchFields}
          handleWarningMsg={self.handleWarningMsg}
          handleSearch={self.searchByDetails} />
      );
    }

  }


};

//----------------------------------------------------------------------
//   OSWidgetSearchTab -- Tab for search criteria
//   TO DO : Based on inputs from team
//       CSS can also be localized to component than direct access
//       Validation message directly access DOM should it change?
//          Temporarily moved it to parent
//----------------------------------------------------------------------
class OSWidgetSearchTab extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      tabIndicator: this.props.tabData.tabIndicator,
      searchValue: this.props.tabData.searchQry.id || '',
      searchValue2: this.props.tabData.searchQry.id2 || '',
      searchValue3: this.props.tabData.searchQry.id3 || '',
      searchField: this.props.tabData.searchQry.searchField || this.props.tabData.searchField || '',
      searchField2: this.props.tabData.searchQry.searchField2 || this.props.tabData.searchField2 || '',
      searchField3: this.props.tabData.searchQry.searchField3 || this.props.tabData.searchField3 || '',
      dateTypeValue: this.props.tabData.searchQry.dateTypeValue || this.props.tabData.dateType || '',
      dateRangeValue: this.props.tabData.searchQry.dateRange || '',
      searchFieldWarn: false,
      dateRangeWarn: false,
      dateTypeWarn: false,
      itemLevelExactMatchState: false,
      itemLevelExactMatchCheck: false
    };
    this.onChange = this.onChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.pasteExcel = this.pasteExcel.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.validateSearchFields = this.validateSearchFields.bind(this);
    this.updateSearchField = this.updateSearchField.bind(this);
    this.updateDateRange = this.updateDateRange.bind(this);
    this.updateDateType = this.updateDateType.bind(this);
    this.handleItemLevelExactMatch = this.handleItemLevelExactMatch.bind(this);
    this.handleOrderLevelFilterMode = this.handleOrderLevelFilterMode.bind(this);
    this.handleOrderTypeFilterMode = this.handleOrderTypeFilterMode.bind(this);
    this.handleAddAdditionalFilter = this.handleAddAdditionalFilter.bind(this);
    this.handleRemoveAdditionalFilter = this.handleRemoveAdditionalFilter.bind(this);
  }

  componentDidMount() {
    if (UserSettings.fields.order.itemLevelExactMatch != undefined) {
      this.setState({itemLevelExactMatchState: UserSettings.fields.order.itemLevelExactMatch})
      this.setState({itemLevelExactMatchCheck: UserSettings.fields.order.itemLevelExactMatch})
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.itemLevelExactMatchState != this.state.itemLevelExactMatchCheck) {
      this.state.itemLevelExactMatchCheck = this.state.itemLevelExactMatchState
      UpdateUserSettings(function (err, resp) {
        console.log('user setting written:', err, resp);
      });
    }

  }

  onChange(e) {
    const newState = {};
    switch (e.target.id) {
      case 'compSearchId': this.state.searchValue = e.target.value; break;
      case 'compSearchId2': this.state.searchValue2 = e.target.value; break;
      case 'compSearchId3': this.state.searchValue3 = e.target.value; break;
    }
    this.setState({ ...newState });
  }

  handleKeyDown(e) {
    if (e.keyCode == 13) {
      this.handleSearch();
    }
  }

  pasteExcel(e) {
    //console.log("pasteExcel");
    //console.log("'"+this.state.searchValue+"'")
    var clipText = "";
    if (window.clipboardData && window.clipboardData.getData) { // IE
      clipText = window.clipboardData.getData('Text');
    } else if (e.clipboardData && e.clipboardData.getData) {
      clipText = e.clipboardData.getData('text/plain');
    }
    //e.clipboardData.setData('text/plain','');
    // split into rows
    var clipRows = clipText.split("\n");

    // split rows into columns
    for (var i = 0; i < clipRows.length; i++) {
      clipRows[i] = clipRows[i].split("\t");
    }

    var searchValueNo = "";

    switch (e.target.id) {
      case 'compSearchId': searchValueNo = "searchValue"; break;
      case 'compSearchId2': searchValueNo = "searchValue" + 2; break;
      case 'compSearchId3': searchValueNo = "searchValue" + 3; break;
    }

    var currentValue = this.state[searchValueNo];
    var target = e.target;
    var selectionStart = target.selectionStart;
    var selectionEnd = target.selectionEnd;

    var pastedContent = "";
    var comma = "";
    //console.log('pasteExcel nr rows=', clipRows.length, ' nr cols=', clipRows[0].length );
    for (var r = 0; r < clipRows.length; r++) {
      var str = String.prototype.trim.call(clipRows[r]);
      //console.log("'"+str+"'")
      if (str != "") {
        pastedContent = pastedContent + comma + str;
        comma = ", ";
      }
    }

    var beforeSelection = currentValue.substring(0, selectionStart);
    var afterSelection = currentValue.substring(selectionEnd);
    var inputStr = beforeSelection + pastedContent + afterSelection;

    //console.log("inputStr: '"+inputStr+"'")
    inputStr = inputStr.replace(/, *,/g, ",");
    //console.log("searchValue: '"+this.state[searchValueNo]+"'")
    //console.log("'"+this.state[searchValueNo].length+"'")
    var newState = {};
    newState[searchValueNo] = inputStr;
    this.setState({ ...newState });
    e.preventDefault();
    return false
  }

  handleSearch() {

    $("#resultMsg").empty();
    $("#resultMsg").removeClass("alert alert-danger info-alert");

    if (this.state.searchField == "orderStatus"
      || this.state.searchField2 == "orderStatus"
      || this.state.searchField3 == "orderStatus") {

      var searchValueNo;
      var searchFieldNo;
      var btnNo = "";

      if (this.state.searchField == "orderStatus") {
        searchValueNo = "searchValue";
        searchFieldNo = "searchField"
      } else
        if (this.state.searchField2 == "orderStatus") {
          btnNo = 2;
          searchValueNo = "searchValue" + btnNo;
          searchFieldNo = "searchField" + btnNo;
        } else
          if (this.state.searchField3 == "orderStatus") {
            btnNo = 3;
            searchValueNo = "searchValue" + btnNo;
            searchFieldNo = "searchField" + btnNo;
          }

      var searchFieldSelectedText = this.props.tabData.searchFieldMap[this.state[searchFieldNo]];
      var dateTypeSelectedText = this.props.tabData.dateTypeMap[this.state.dateTypeValue];
      $("#orderSelectList").hide();
      $("#exportToExcel").hide();
      $("#backButton").hide();

      this.state[searchValueNo] = "";

      var statiList = ['Submitted', 'Processing', 'Production', 'Shipped', 'Delivered', 'ShipmentCanceled', 'Cancelled'];

      for (i = 0; i < statiList.length; i++) {

        if ($("#btn_" + btnNo + "_" + statiList[i]).hasClass("btn-primary")) {
          if (this.state[searchValueNo] != "") {
            this.state[searchValueNo] += "," + statiList[i];
          } else {
            this.state[searchValueNo] = statiList[i];
          }
        };
      }

      //this.appendState("Production");
      var isValid = this.validateSearchFields();
      if (isValid) {
        this.props.handleSearch(
          {
            id: this.state.searchValue,
            id2: this.state.searchValue2,
            id3: this.state.searchValue3,
            searchField: this.state.searchField,
            searchField2: this.state.searchField2,
            searchField3: this.state.searchField3,
            dateType: dateTypeSelectedText,
            dateTypeValue: this.state.dateTypeValue,
            dateRange: this.state.dateRangeValue,
            tabIndicator: this.state.tabIndicator
          });
      }
    } else {
      // Validate the input
      var isValid = this.validateSearchFields();
      // if valid proceed to execute the search
      if (isValid) {
        var searchFieldSelectedText = this.props.tabData.searchFieldMap[this.state.searchField];
        var dateTypeSelectedText = this.props.tabData.dateTypeMap[this.state.dateTypeValue];
        $("#orderSelectList").hide();
        $("#exportToExcel").hide();
        $("#backButton").hide();
        this.props.handleSearch(
          {
            id: this.state.searchValue.trim(),
            id2: this.state.searchValue2.trim(),
            id3: this.state.searchValue3.trim(),
            searchField: this.state.searchField,
            searchField2: this.state.searchField2,
            searchField3: this.state.searchField3,
            dateType: dateTypeSelectedText,
            dateTypeValue: this.state.dateTypeValue,
            dateRange: this.state.dateRangeValue,
            tabIndicator: this.state.tabIndicator
          });
      }
    }
  }

  handleReset() {
    this.props.handleReset(); // Delegate to Parent
    this.state.searchValue = '';
    if (this.props.tabData.searchQry.searchBy == "D") {
      this.state.searchField = 'serialNo';
    } else {
      this.state.searchField = 'quickSearch';
      $("#compSearchId").attr('placeholder', this.state.searchField == "quickSearch" ? this.props.tabData.searchHint : '');
    }
    this.state.dateTypeValue = 'purchaseOrderDate';
    this.state.dateRangeValue = '';

    this.state.searchFieldWarn = false;
    this.state.dateRangeWarn = false;
    this.state.dateTypeWarn = false;

    this.setState(this.state);
    this.handleRemoveAdditionalFilter();
  }

  validateSearchFields() {
    var isValid = true;
    // Delegate to Parent
    isValid = this.props.validateSearchFields();

    this.state.searchFieldWarn = false;
    this.state.dateRangeWarn = false;
    this.state.dateTypeWarn = false;

    if (!((this.state.dateRangeValue != "")
      || (this.state.searchValue != "" && this.state.searchField != ""))) {
      isValid = false;
      this.props.handleWarningMsg({ message: T('warn_search_criteria') });
    } else if ((this.state.dateTypeValue == "" && this.state.dateRangeValue == "")
      && this.state.searchValue != "" && this.state.searchField != ""
      && this.state.searchValue.length < 6
      && (this.props.tabData.tabIndicator == 'D' || this.props.tabData.tabIndicator == 'CP')) {
      isValid = false;
      this.props.handleWarningMsg({ message: T('warn_details_search_len') });
    }

    if (this.state.searchField2 != "orderStatus" && this.state.searchValue2 == "" && $('#searchElement_2').is(":visible")) {
      isValid = false;
      this.props.handleWarningMsg({ message: T('warn_details_empty_additional_filter') });
    }
    if (this.state.searchField3 != "orderStatus" && this.state.searchValue3 == "" && $('#searchElement_3').is(":visible")) {
      isValid = false;
      this.props.handleWarningMsg({ message: T('warn_details_empty_additional_filter') });
    }
    if (this.state.searchField == this.state.searchField2 && $('#searchElement_2').is(":visible")
      || this.state.searchField == this.state.searchField3 && $('#searchElement_3').is(":visible")
      || this.state.searchField2 == this.state.searchField3 && ($('#searchElement_2').is(":visible") && $('#searchElement_3').is(":visible"))) {
      isValid = false;
      this.props.handleWarningMsg({ message: T('warn_details_same_filter') });
    }

    // Set state to trigger refresh;
    this.setState(this.state);

    return isValid;
  }

  updateSearchField(val, id) {

    if (val != 'quickSearch' && !$('#searchElement_2').is(":visible")) {
      $('#searchElement_GlyphAdd').show();
    } else {
      $('#searchElement_GlyphAdd').hide();
    }

    if (id == '1') {
      id = "";
    }

    var currentSearchField = "searchField" + id;
    var currentSearchValue = "searchValue" + id;

    if (val == "") {
      this.state[currentSearchValue] = "";
    }

    this.state[currentSearchField] = val;
    this.setState(this.state);
    $("#compSearchId" + id).attr('placeholder', val == "quickSearch" ? this.props.tabData.searchHint : '');

    if (val == 'quickSearch' && $('#searchElement_2').is(":visible")) {
      this.handleRemoveAdditionalFilter();
    }

  }

  updateDateRange(val) {
    this.state.dateRangeValue = val;
    this.setState(this.state);
  }

  updateDateType(val) {
    this.state.dateTypeValue = val;
    this.setState(this.state);
  }

  handleItemLevelExactMatch = e => {
    UserSettings.fields.order.itemLevelExactMatch = e.target.checked;

    //this.setState({itemLevelExactMatchState: e.target.checked});
    this.state.itemLevelExactMatchState = e.target.checked;
    this.setState(this.state);

    if (this.props.tabData.searchQry.bucket) {

      if (this.props.tabData.searchQry.type == 'dashboard') {
        console.log("Execute some kind of refresh for " + this.props.tabData.searchQry.bucket);
        //self.DashboardRow.originalSpec.drill(this.props.tabData.searchQry.bucket,"total");
      } else {
        console.log("Dont execute search -yet-, im in tab " + this.props.tabData.searchQry.bucket + " continue here when Dataservices are available for item level");
      }

    } else {

      if (this.props.tabData.searchQry.type == 'searchresult') {
        this.handleSearch();
      }
    }

  }

  handleOrderLevelFilterMode(newMode) {
    console.log('handleFilterMode', newMode);
    UserSettings.fields.order.orderLevelOutputmode = newMode;
    this.state.orderLevelOutputmode = newMode;
    this.setState(this.state);

    UpdateUserSettings(function (err, resp) {
      console.log('user setting written:', err, resp);
    });

    if (this.props.tabData.searchQry.bucket) {

      if (this.props.tabData.searchQry.type == 'dashboard') {
        console.log("Execute some kind of refresh for " + this.props.tabData.searchQry.bucket);
        //self.DashboardRow.originalSpec.drill(this.props.tabData.searchQry.bucket,"total");
      } else {
        console.log("Dont execute search -yet-, im in tab " + this.props.tabData.searchQry.bucket + " continue here when Dataservices are available for item level");
      }

    } else {

      if (this.props.tabData.searchQry.type == 'searchresult') {
        this.handleSearch();
      }
    }


  }

  handleOrderTypeFilterMode(newMode) {
    console.log('handleFilterMode', newMode);
    UserSettings.fields.order.orderTypeOutputmode = newMode;
    this.state.orderTypeOutputmode = newMode;
    this.setState(this.state);

    UpdateUserSettings(function (err, resp) {
      console.log('user setting written:', err, resp);
    });

    if (this.props.tabData.searchQry.type == 'searchresult') {
      this.handleSearch();
    }
  }

  handleAddAdditionalFilter() {
    console.log('add new search box');

    if ($('#searchElement_2').is(":visible")) {
      this.updateSearchField("cbn", 3)
      $('#searchElement_3').show();
      $('#searchElement_2_GlyphAdd').hide();
      $('#searchElement_2_GlyphRem').hide();
    } else {
      this.updateSearchField("cbn", 2)
      $('#searchElement_2').show();
      $('#searchElement_2_GlyphAdd').show();
      $('#searchElement_GlyphAdd').hide();
    }

  }

  handleRemoveAdditionalFilter() {
    console.log('remove search box');

    if (this.state.searchField == "quickSearch") {
      this.state.searchField3 = "";
      this.updateSearchField(this.state.searchField3, 3)
      $('#searchElement_3').hide();

      this.state.searchField2 = "";
      this.updateSearchField(this.state.searchField2, 2)
      $('#searchElement_2').hide();
      $('#searchElement_GlyphAdd').hide();
    } else

      if ($('#searchElement_3').is(":visible")) {
        this.state.searchField3 = "";
        this.updateSearchField(this.state.searchField3, 3)
        $('#searchElement_3').hide();
        $('#searchElement_2_GlyphAdd').show();
        $('#searchElement_2_GlyphRem').show();
      } else {
        this.state.searchField2 = "";
        this.updateSearchField(this.state.searchField2, 2)
        $('#searchElement_2').hide();
        $('#searchElement_GlyphAdd').show();
      }

  }

  render() {

    var searchFieldDropDown = [];
    //searchFieldDropDown.push(<option value=''>{T('Search Value')}</option>);

    for (var key in this.props.tabData.searchFieldMap) {
      if (this.props.tabData.searchFieldMap.hasOwnProperty(key)) {
        searchFieldDropDown.push(<option value={key}>{this.props.tabData.searchFieldMap[key]}</option>);
      }
    }

    var dateTypeDropDown = [];
    //dateTypeDropDown.push(<option value=''>{T('Select Date Type')}</option>);

    for (var key in this.props.tabData.dateTypeMap) {
      if (this.props.tabData.dateTypeMap.hasOwnProperty(key)) {
        dateTypeDropDown.push(<option value={key}>{this.props.tabData.dateTypeMap[key]}</option>);
      }
    }

    var ranges = {};
    ranges[T('Yesterday')] = [moment().subtract(1, 'days'), moment().subtract(1, 'days')];
    ranges[T('Last Week')] = [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')];
    ranges[T('Current Week')] = [moment().startOf('week'), moment().endOf('week')];
    ranges[T('Last Month')] = [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
    ranges[T('Current Month')] = [moment().startOf('month'), moment().endOf('month')];
    ranges[T('Last 3 Months')] = [moment().subtract(3, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
    ranges[T('Current Year')] = [moment().startOf('year'), moment().endOf('year')];

    var fieldSelectDefault = ""
    if (this.props.tabData.searchField != undefined) {
      fieldSelectDefault = "defaultValue={this.props.tabData.searchField}"
    }
    var dateSelectDefault = ""
    if (this.props.tabData.dateTypeValue != undefined) {
      dateSelectDefault = "defaultValue={this.props.tabData.dateTypeValue}"
    }

    //var self = this;

    var orderTypeFilterToggle = [];
    var orderTypeFilterMode = 'all';
    var orderTypeFilterModeTitle = T('show all order types');
    var orderTypeFilterModeLabel = 'All'
    var orderTypeFilterSpinningStyle = { 'marginLeft': '10px' }

    if (UserSettings.fields.order.orderTypeOutputmode) {
      orderTypeFilterMode = UserSettings.fields.order.orderTypeOutputmode;
    }
    var orderTypeFilterModeIcon = "glyphicon glyphicon-list-alt";

    if (orderTypeFilterMode == 'tradeShow') {
      //orderTypeFilterModeIcon = "glyphicon glyphicon-export";
      orderTypeFilterModeTitle = T('show only trade orders');
      orderTypeFilterModeLabel = 'Trade Orders'
      orderTypeFilterSpinningStyle = { 'marginLeft': '10px', 'display': 'none' }
    }
    if (orderTypeFilterMode == 'claimShow') {
      //orderTypeFilterModeIcon = "glyphicon glyphicon-import";
      orderTypeFilterModeTitle = T('show only claim orders');
      orderTypeFilterModeLabel = 'Claim Orders'
      orderTypeFilterSpinningStyle = { 'marginLeft': '10px', 'display': 'none' }
    }

    var orderLevelFilterToggle = [];
    var orderLevelFilterMode = 'headerShow';
    var orderLevelFilterModeTitle = T('show records per order');
    var orderLevelFilterModeLabel = T('Order Data');
    var orderLevelFilterSpinningStyle = { 'marginLeft': '10px' }
    var itemLevelExactMatch = this.state.itemLevelExactMatchState;
    $('#orderLevelFilterCheck').hide();

    if (UserSettings.fields.order.orderLevelOutputmode) {
      orderLevelFilterMode = UserSettings.fields.order.orderLevelOutputmode;
    }
    if (UserSettings.fields.order.itemLevelExactMatch) {
      //itemLevelExactMatch = UserSettings.fields.order.itemLevelExactMatch;
      //console.log('setting itemLevelExactMatch to ',itemLevelExactMatch)
    }
    var orderLevelFilterModeIcon = "glyphicon glyphicon-th";
    if (orderLevelFilterMode == 'itemShow') {
      orderLevelFilterModeIcon = "glyphicon glyphicon-th-list";
      orderLevelFilterModeTitle = T('show records per item');
      orderLevelFilterModeLabel = T('Item Data');
      orderLevelFilterSpinningStyle = { 'marginLeft': '10px', 'display': 'none' }
      $('#orderLevelFilterCheck').show();
    }

    if (this.props.tabData.tabIndicator == 'H') {
      orderLevelFilterToggle.push(
        <div className="btn-group pull-left" style={{ 'display': 'inline', 'marginLeft': '2px', 'marginLeft': '6px' }}>
          <button className="btn btn-primary btn-inline btn-sm leftMargin10 dropdown-toggle" type="button" id="orderLevelOutputmode" title={orderLevelFilterModeTitle} data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
            <i className={orderLevelFilterModeIcon} /> {orderLevelFilterModeLabel}
          </button> 
          <div id="orderLevelFilterCheck" style={{'display': 'inline'}}>
            &nbsp;&nbsp;<input type="checkbox" id="itemLevelExactMatchCheck" style={{'display': 'inline'}} title={T('exact match only')} checked={itemLevelExactMatch} onChange={this.handleItemLevelExactMatch} /> {T('exact match only')}
          </div>
          <ul className="dropdown-menu" aria-labelledby="orderLevelOutputmode">
            <li><a href="#" onClick={this.handleOrderLevelFilterMode.bind(null, 'headerShow')}><i className="btn-sm glyphicon glyphicon-th" />{T('Order Data')}</a></li>
            <li><a href="#" onClick={this.handleOrderLevelFilterMode.bind(null, 'itemShow')}  ><i className="btn-sm glyphicon glyphicon-th-list" />{T('Item Data')}</a></li>
          </ul>
        </div>
      )
      /*
          orderTypeFilterToggle.push(            
            <div className="btn-group pull-left" style={{'display':'inline', 'marginLeft':'2px', 'marginLeft':'6px'}}>
              <button className="btn btn-primary btn-inline btn-sm leftMargin10 dropdown-toggle" type="button" id="orderTypeOutputmode" title={orderTypeFilterModeTitle} data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                <i className={orderTypeFilterModeIcon} /> {orderTypeFilterModeLabel}
              </button>
              <ul className="dropdown-menu" aria-labelledby="orderTypeOutputmode">
                <li><a href="#" onClick={this.handleOrderTypeFilterMode.bind(null,'all')}        ><i className={orderTypeFilterModeIcon}  /> all</a></li>
                <li><a href="#" onClick={this.handleOrderTypeFilterMode.bind(null,'tradeShow')}  ><i className={orderTypeFilterModeIcon}  /> Trade</a></li>
                <li><a href="#" onClick={this.handleOrderTypeFilterMode.bind(null,'claimShow')}  ><i className={orderTypeFilterModeIcon}  /> Claim</a></li>
              </ul>                   
            </div>
            )
      */
    }

    return (
      <div style={{ display: "flex" }}>
        <div style={{ flexGrow: 20 }}>
          <div className="blockTitle" style={{ 'boxShadow': '2px 3px 13px rgba(0,0,0,.2)' }}>
            {this.props.tabData.blockTitle}:
          </div>
          <div className="blockBody" style={{ 'boxShadow': '2px 3px 13px rgba(0,0,0,.2)' }}>
            <table className="formTableExt" width="100%">
              <tr id="searchElement">

                <td width="1%">
                  <i id="searchElement_GlyphAdd" className="glyphicon glyphicon-plus" onClick={this.handleAddAdditionalFilter} style={{ "color": "#0096d6", "cursor": "pointer", "display": "none" }}></i>
                </td>

                <td width="24%">
                  <OSSelectionCmp id="1"
                    warn={this.state.searchFieldWarn}
                    onChange={this.updateSearchField}
                    selectionOptions={this.props.tabData.searchFieldMap}
                    selectedValue={this.state.searchField}
                    ref="fieldSelection"
                    tabData={this.props.tabData} />
                </td>
                <td colSpan="2" width="75%">
                  <SearchValueBox id="compSearchId"
                    searchField={this.state.searchField}
                    value={this.state.searchValue}
                    onChange={this.onChange}
                    onPaste={this.pasteExcel}
                    placeholder={this.props.tabData.searchHint}
                    onKeyDown={this.handleKeyDown} />
                </td>
              </tr>

              <tr id="searchElement_2" style={{ "display": "none" }}>
                <td width="1%">
                  <i id="searchElement_2_GlyphAdd" className="glyphicon glyphicon-plus" onClick={this.handleAddAdditionalFilter} style={{ "color": "#0096d6", "cursor": "pointer" }}></i>
                </td>
                <td width="24%">
                  <OSSelectionCmp id="2"
                    warn={this.state.searchFieldWarn}
                    onChange={this.updateSearchField}
                    selectionOptions={this.props.tabData.searchFieldMap}
                    selectedValue={this.state.searchField2}
                    ref="fieldSelection" />
                </td>
                <td colSpan="2" width="75%">
                  <SearchValueBox id="compSearchId2"
                    searchField={this.state.searchField2}
                    value={this.state.searchValue2}
                    onChange={this.onChange}
                    onPaste={this.pasteExcel}
                    placeholder={this.props.tabData.searchHint}
                    onKeyDown={this.handleKeyDown} />
                </td>
                <td width="1%">
                  <i id="searchElement_2_GlyphRem" className="glyphicon glyphicon-remove" onClick={this.handleRemoveAdditionalFilter} style={{ "color": "#0096d6", "cursor": "pointer" }}></i>
                </td>
              </tr>

              <tr id="searchElement_3" style={{ "display": "none" }}>
                <td width="1%">
                  &nbsp;
                </td>
                <td width="24%">
                  <OSSelectionCmp id="3"
                    warn={this.state.searchFieldWarn}
                    onChange={this.updateSearchField}
                    selectionOptions={this.props.tabData.searchFieldMap}
                    selectedValue={this.state.searchField3}
                    ref="fieldSelection" />
                </td>
                <td colSpan="2" width="75%">
                  <SearchValueBox id="compSearchId3"
                    searchField={this.state.searchField3}
                    value={this.state.searchValue3}
                    onChange={this.onChange}
                    onPaste={this.pasteExcel}
                    placeholder={this.props.tabData.searchHint}
                    onKeyDown={this.handleKeyDown} />
                </td>
                <td width="1%">
                  <i id="searchElement_3_GlyphRem" className="glyphicon glyphicon-remove" onClick={this.handleRemoveAdditionalFilter} style={{ "color": "#0096d6", "cursor": "pointer" }}></i>
                </td>
              </tr>

              <tr>
                <td width="1%">
                  &nbsp;
                </td>
                <td width="24%" style={{ "textAlign": "right", "fontSize": "14px" }}>{T('Date Range')}:</td>
                <td width="25%">
                  <OSSelectionCmp warn={this.state.dateTypeWarn}
                    onChange={this.updateDateType}
                    selectionOptions={this.props.tabData.dateTypeMap}
                    selectedValue={this.state.dateTypeValue}
                    ref="dateSelection" />
                </td>
                <td width="50%">
                  <OSCalendarRangeCmp warn={this.state.dateRangeWarn}
                    dateRangeValue={this.state.dateRangeValue}
                    ranges={ranges}
                    placeholder={T('dateRangeHint')}
                    onChange={this.updateDateRange}
                    ref="dateRange" />
                </td>
              </tr>
              <tr>
                <td width="1%">
                  &nbsp;
                </td>
                <td width="24%">&nbsp;</td>
                <td colSpan="1" width="50%">
                  <button id="orderSearchButton" className="btn btn-inline btn-primary btn-sm leftMargin10" onClick={this.handleSearch}>{T('Search')}</button>
                  &nbsp;
                  <button className="btn btn-inline btn-primary btn-sm leftMargin10" onClick={this.handleReset}>{T('Reset')}</button>
                  &nbsp;
                </td>
                <td width="25%">
                  {orderLevelFilterToggle}
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    );

  }
};

//----------------------------------------------------------------------
//   OSCalendarRangeCmp -- Custom Calendar Component
//   Properties
//                   warn : True if background needs change color
//               onChange : function that needs to be involed on change value
//                 ranges : Range Options to be used JS Array
//                          ranges[T('Yesterday')]     = [moment().subtract(1,'days'), moment().subtract(1,'days')];
//                          ranges[T('Last Week')]     = [moment().subtract(1,'week').startOf('week'), moment().subtract(1,'week').endOf('week')];
//         dateRangeValue : Default or selected date range
//            placeholder : Place holder text
//----------------------------------------------------------------------
class OSCalendarRangeCmp extends React.Component {

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.attachDatePicker = this.attachDatePicker.bind(this);
  }

  onChange(e) {
    if (this.props.onChange) {
      this.props.onChange(e);
    }
  }

  handleKeyDown(e) {
    // Prevent all keyboard input except Tab for navigation
    if (e.key !== 'Tab') {
      e.preventDefault();
    }
    if (this.props.handleKeyDown) {
      this.props.handleKeyDown(e);
    }
  }

  attachDatePicker() {
    var self = this;
    var ranges = this.props.ranges;

    var dateRangeCmp = ReactDOM.findDOMNode(this.refs["dateRange"]);
    $(dateRangeCmp).daterangepicker({
      ranges: ranges,
      separator: '   to   ',
      opens: 'left',
      format: 'YYYY-MM-DD'
    }, function (start, end, label) {
      // Indivudial fields can be stored in state and used too!!
      self.onChange(start.format('YYYY-MM-DD') + '  to  ' + end.format('YYYY-MM-DD'));
    });
  }

  componentDidMount() {
    this.attachDatePicker();
  }

  render() {
    var defaultClassName = "form-control";
    if (this.props.warn) {
      defaultClassName = "form-control warnTextbox";
    }

    return (
      <input type="text"
        className={defaultClassName}
        value={this.props.dateRangeValue}
        placeholder={this.props.placeholder}
        ref="dateRange"
        onKeyDown={this.handleKeyDown}
        style={{cursor: 'pointer'}} />
    );
  }
};


//----------------------------------------------------------------------
//   ToggleBtnPrimaryDefault -- Will toggle to "primary" when enabled and "default" when disabled
//
//----------------------------------------------------------------------
class ToggleBtnPrimaryDefault extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isChecked: true
    };
    this.btnClick = this.btnClick.bind(this);
  }

  btnClick(event) {
    console.log("btnClick", event);

    this.setState({ isChecked: !this.state.isChecked });

    console.log(this.state.isChecked);
    console.log(event.currentTarget.id);

    if (this.state.isChecked === true) {
      $("#" + event.currentTarget.id).removeClass("btn-default");
      $("#" + event.currentTarget.id).addClass("btn-primary");
    } else {
      $("#" + event.currentTarget.id).removeClass("btn-primary");
      $("#" + event.currentTarget.id).addClass("btn-default");
    }

  }

  render() {

    var btnName = "btn_" + this.props.btnNo + "_" + this.props.name;

    return (
      <button id={btnName} className="btn btn-default" onClick={this.btnClick} >
        {T(this.props.name)}
      </button>
    );
  }
};

//----------------------------------------------------------------------
//   SearchValueBox -- render the value input boxes
//
//----------------------------------------------------------------------
class SearchValueBox extends React.Component {

  constructor(props) {
    super(props);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handlePaste = this.handlePaste.bind(this);
  }

  handleKeyDown(e) {
    if (this.props.onKeyDown) {
      return this.props.onKeyDown(e);
    }
  }

  handleChange(e) {
    if (this.props.onChange) {
      return this.props.onChange(e);
    }
  }

  handlePaste(e) {
    if (this.props.onPaste) {
      return this.props.onPaste(e);
    }
  }

  render() {

    var statusBtnGroup = [];
    var btnNo = "";

    if (this.props.searchField == "orderStatus") {

      if (this.props.id == "compSearchId2") {
        btnNo = 2;
      } else
        if (this.props.id == "compSearchId3") {
          btnNo = 3;
        }
      var statiList = ['Submitted', 'Processing', 'Production', 'Shipped', 'Delivered', 'ShipmentCanceled', 'Cancelled'];

      for (i = 0; i < statiList.length; i++) {

        var lblName = "btn_" + btnNo + "_" + statiList[i];
        statusBtnGroup.push(<ToggleBtnPrimaryDefault name={statiList[i]} btnNo={btnNo} />)
      }

      return (
        <div className="btn-toolbar" data-toggle="buttons" id={this.props.id} >
          {statusBtnGroup}
        </div>
      );

    } else {

      return (
        <input type="text" className="form-control" id={this.props.id}
          value={this.props.value}
          onChange={this.handleChange}
          onPaste={this.handlePaste}
          placeholder={this.props.placeholder}
          onKeyDown={this.handleKeyDown} autoComplete="off" />
      );
    }
  }
};

//----------------------------------------------------------------------
//   OSSelectionCmp -- Custom DropDown Component
//   Properties
//                   warn : True if background needs change color
//               onChange : function that needs to be involed on change value
//       selectionOptions : Options as JS Object {'': 'Please Select', K1':'This is K1', 'K2' : 'This is K2'}
//          selectedValue : default selected value
//----------------------------------------------------------------------
class OSSelectionCmp extends React.Component {

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  onChange(e) {
    if (this.props.onChange) {
      this.props.onChange(e.target.value, this.props.id)
    }
  }

  handleKeyDown(e) {
    // Delegate to parent
    if (this.props.handleKeyDown) {
      this.props.handleKeyDown(e);
    }
  }

  render() {
    var defaultClassName = "form-control";
    if (this.props.warn) {
      defaultClassName = "form-control warnTextbox";
    }
    var selectionOptions = [];

    for (var key in this.props.selectionOptions) {
      if (this.props.selectionOptions.hasOwnProperty(key)) {
        if (this.props.id != 1 && key == "quickSearch") {
          //skip quickSearch option for additional search filter Cmp
        } else {
          selectionOptions.push(<option value={key}>{this.props.selectionOptions[key]}</option>);
        }

      }
    }

    return (
      <select id={this.id}
        className={defaultClassName}
        onChange={this.onChange}
        value={this.props.selectedValue}
        ref="dateSelection"
        onKeyDown={this.handleKeyDown} >
        {selectionOptions}
      </select>
    );
  }
};

//----------------------------------------------------------------------
//   DashboardChartContainer
//
//----------------------------------------------------------------------
class DashboardChartContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      backlogChartsData: {
        total: { rows: [], size: 0, type: '' },
        trade: { rows: [], size: 0, type: '' },
        claim: { rows: [], size: 0, type: '' },
        contract: { rows: [], size: 0, type: '' }
      }
    }
    this.getBacklogChartsData = this.getBacklogChartsData.bind(this);
    this.getBacklogOrderTypeChartData = this.getBacklogOrderTypeChartData.bind(this);
  }

  componentDidMount() {
    this.getBacklogChartsData();
  }

  getBacklogChartsData() {
    let backlogChartsData = {
      total: { rows: [], size: 0, type: '' },
      trade: { rows: [], size: 0, type: '' },
      claim: { rows: [], size: 0, type: '' },
      contract: { rows: [], size: 0, type: '' }
    };
    let totalChartData = {
      rows: [],
      size: this.props.data.submittedOrders.total,
      type: 'Total'
    };

    if (this.props.data.submitOrders.total) {
      const submitted = {
        "id": "Submitted",
        "label": "Submitted: " + this.props.data.submitOrders.total,
        "value": this.props.data.submitOrders.total
      };
      totalChartData.rows.push(submitted);
    }

    if (this.props.data.acceptedOrders.total) {
      const accepted = {
        "id": "Processing",
        "label": "Processing: " + this.props.data.acceptedOrders.total,
        "value": this.props.data.acceptedOrders.total
      };
      totalChartData.rows.push(accepted);
    }

    if (this.props.data.productionOrders.total) {
      const production = {
        "id": "Production",
        "label": "Production: " + this.props.data.productionOrders.total,
        "value": this.props.data.productionOrders.total
      };
      totalChartData.rows.push(production);
    }

    if (this.props.data.shippedOrders.total) {
      const shipped = {
        "id": "Shipped",
        "label": "Shipped: " + this.props.data.shippedOrders.total,
        "value": this.props.data.shippedOrders.total
      };
      totalChartData.rows.push(shipped);
    }

    if (this.props.data.deliveredOrders.total) {
      const delivered = {
        "id": "Delivered",
        "label": "Delivered: " + this.props.data.deliveredOrders.total,
        "value": this.props.data.deliveredOrders.total
      };
      totalChartData.rows.push(delivered);
    }

    if (this.props.data.shipmentCanceledOrders.total) {
      const shipmentCanceled = {
        "id": "ShipmentCanceled",
        "label": "Ship. Canceled: " + this.props.data.shipmentCanceledOrders.total,
        "value": this.props.data.shipmentCanceledOrders.total
      }
      totalChartData.rows.push(shipmentCanceled);
    }

    if (this.props.data.cancelledOrders.total) {
      const canceled = {
        "id": "Canceled",
        "label": "Canceled: " + this.props.data.cancelledOrders.total,
        "value": this.props.data.cancelledOrders.total
      }
      totalChartData.rows.push(canceled);
    }

    backlogChartsData.total = totalChartData;

    if (this.props.data['Trade Order']) {
      backlogChartsData.trade = this.getBacklogOrderTypeChartData(this.props.data['Trade Order'], 'Trade Order');
    }
    if (this.props.data['Claim Order']) {
      backlogChartsData.claim = this.getBacklogOrderTypeChartData(this.props.data['Claim Order'], 'Claim Order');
    }
    if (this.props.data['Contract Order']) {
      backlogChartsData.contract = this.getBacklogOrderTypeChartData(this.props.data['Contract Order'], 'Contract Order');
    }

    this.setState({
      backlogChartsData: backlogChartsData
    })
  }

  getBacklogOrderTypeChartData(data, type) {
    let chartData = {
      rows: [],
      size: 0,
      type: type
    }

    if (data.Submitted) {
      const submitted = {
        "id": "Submitted",
        "label": "Submitted: " + data.Submitted,
        "value": data.Submitted
      };
      chartData.rows.push(submitted);
    }

    if (data.Processing) {
      const accepted = {
        "id": "Processing",
        "label": "Processing: " + data.Processing,
        "value": data.Processing
      };
      chartData.rows.push(accepted);
    }

    if (data.Production) {
      const production = {
        "id": "Production",
        "label": "Production: " + data.Production,
        "value": data.Production
      };
      chartData.rows.push(production);
    }

    if (data.Shipped) {
      const shipped = {
        "id": "Shipped",
        "label": "Shipped: " + data.Shipped,
        "value": data.Shipped
      };
      chartData.rows.push(shipped);
    }

    if (data.Delivered) {
      const delivered = {
        "id": "Delivered",
        "label": "Delivered: " + data.Delivered,
        "value": data.Delivered
      };
      chartData.rows.push(delivered);
    }

    if (data.ShipmentCanceled) {
      const shipmentCanceled = {
        "id": "ShipmentCanceled",
        "label": "Ship. Canceled: " + data.ShipmentCanceled,
        "value": data.ShipmentCanceled
      }
      chartData.rows.push(shipmentCanceled);
    }

    if (data.CANCELED) {
      const canceled = {
        "id": "Canceled",
        "label": "Canceled: " + data.CANCELED,
        "value": data.CANCELED
      }
      chartData.rows.push(canceled);
    }

    chartData.size = data.total;

    return chartData;
  }

  render() {
    var totalChart = this.state.backlogChartsData.total;
    var tradeChart = this.state.backlogChartsData.trade;
    var claimChart = this.state.backlogChartsData.claim;
    var contractChart = this.state.backlogChartsData.contract;

    return (
      <>
        <div className="section-title">Backlog</div>
        <div className="chart-section">
          {totalChart.size > 0 ? <DashboardCharts data={totalChart} title='Total' /> : null}
          {tradeChart.size > 0 ? <DashboardCharts data={tradeChart} title='Trade Order' /> : null}
          {claimChart.size > 0 ? <DashboardCharts data={claimChart} title='Claim Order' /> : null}
          {contractChart.size > 0 ? <DashboardCharts data={contractChart} title='Contract Order' /> : null}
        </div>
      </>
    )
  }
}

//----------------------------------------------------------------------
//   DashboardCharts
//
//----------------------------------------------------------------------
class DashboardCharts extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      colors: [],
      legendStyle: [],
      chartData: []
    }
    this.setCharts = this.setCharts.bind(this);
    this.centeredMetric = this.centeredMetric.bind(this);
    this.showDrill = this.showDrill.bind(this);
  }

  componentDidMount() {
    this.setCharts();
  }

  setCharts() {
    const orderType = this.props.data.type;
    const chartData = this.props.data.rows;
    const colors = [];

    for (var i = 0; i < chartData.length; i++)
      if (statusColors[chartData[i].id.toLowerCase()])
        colors.push(statusColors[chartData[i].id.toLowerCase()])

    const legendStyle = [
      {
        anchor: 'left',
        direction: 'column',
        justify: false,
        translateX: -100,
        translateY: 0,
        itemsSpacing: 7,
        itemWidth: 100,
        itemHeight: 12,
        itemTextColor: '#333',
        itemDirection: 'left-to-right',
        itemOpacity: 1,
        symbolSize: 12,
        symbolShape: 'circle',
        effects: [
          {
            on: 'hover',
            style: {
              itemTextColor: '#0096D6'
            }
          }
        ],
        onClick: (d) => {
          this.showDrill(orderType, d.id)
        }
      }
    ];

    this.setState({
      loading: false,
      colors: colors,
      legendStyle: legendStyle,
      chartData: chartData
    })
  }

  showDrill(orderType, statusRange) {

    $("#resultMsg").html("");
    $("#resultMsg").removeClass("alert alert-danger info-alert");
    var params = {};
    var searchQry = {};

    params = this.getParams(orderType, statusRange);
    searchQry.bucket = params.bucket;
    searchQry.range = params.range;
    ReactDOM.render(
      <OSLandingPage size={"large"} type={"dashboard"} hideGrid={true} searchQry={searchQry} />,
      document.getElementById('mainbody')
    );

    POST("/os/ossui/v1/ex/externalDrilldown", params, function (result) {
      console.log("result=", result)
      state.order = result;
      state.searchQry = searchQry;
      state.type = "dashboard";
      state.withPrices = result.withPrices;
      $('#ossOrderModal').modal('hide');
      ReactDOM.render(
        <ModalWidgetWaiting
          size={"large"} />
        , document.getElementById('externalWidget')
      );
      if (result.data.rows.length >= 1) {
        if (result.status == 'B') {
          $("#resultMsgOrder").html(T("Only first 2000 orders are shown"));
          $("#resultMsgOrder").addClass("info-alert");
          $("#resultMsgOrder").show();
        } else {
          $("#resultMsgOrder").hide();
        }
        var landingPage =
          ReactDOM.render(
            <OSLandingPage size={"large"} type={"dashboard"} order={result} hideGrid={false} searchQry={searchQry} />,
            document.getElementById('mainbody')
          );
        highlightBucket(params.bucket, params.range);

      } else if (result.data.rows.length == 1111) {
        var Params = {
          lookupType: "legacy_order_no",
          lookupValue: result.data.rows[0].legacy_order_no,
          callingSystem: 'quicksearch'
        }
        ReactDOM.render(
          <ModalWidgetWaiting
            size={"large"} />
          , document.getElementById('externalWidget')
        );
        $('#ossOrderModal').modal({ backdrop: 'static' });
        GET("/os/ossui/v1/ex/widget/order", Params, function (resp) {

          if (resp.status == 'N') {
            $("#resultMsg").html(T(resp.message));
            $("#resultMsg").removeClass("info-alert");
            $("#resultMsg").addClass("alert alert-danger");//alert();
          } else {

            if (resp.session && resp.session != undefined) {
              console.log('setting session', resp.session);
              document.cookie = 'session=' + resp.session + '; path=/;'
            }

            $('#ossOrderModal').modal('hide');
            $("#orderSelectList").show();
            $("#exportToExcel").show();

            ReactDOM.render(
              <OSWidget
                order={resp.data} />
              , document.getElementById('externalWidget')
            );

            $('#ossOrderModal').modal({ backdrop: 'static' });
          }
        });
      } else {
        ReactDOM.render(
          <OSLandingPage size={"large"} type={"search"} order={"order"} searchQry={searchQry} />,
          document.getElementById('mainbody')
        );
        if (result.status == 'B') {
          $("#resultMsg").html(T("warn_search_exeed_more_than") + " 2000. " + T("warn_no_search_result") + ". " + T("warn_refine_search"));
          $("#resultMsg").removeClass("alert alert-danger");
          $("#resultMsg").addClass("info-alert");
        } else {
          $("#resultMsg").html(T(result.message));
          $("#resultMsg").removeClass("info-alert");
          $("#resultMsg").addClass("alert alert-danger");
        }
      }
    });

  }

  getParams(orderType, statusRange) {
    var req = {};
    req.orderLevelOutputmode = UserSettings.fields.order.orderLevelOutputmode;
    req.itemLevelExactMatch = UserSettings.fields.order.itemLevelExactMatch;

    if (orderType === 'Total') {
      req.range = orderType.toLowerCase();
      switch (statusRange.toLowerCase()) {
        case 'submitted':
          req.bucket = 'submitOrders';
          break;
        case 'accepted':
          req.bucket = 'acceptedOrders';
          break;
        case 'production':
          req.bucket = 'productionOrders';
          break;
        case 'shipped':
          req.bucket = 'shippedOrders';
          break;
        case 'delivered':
          req.bucket = 'deliveredOrders';
          break;
        case 'shipmentCanceled':
          req.bucket = 'shipmentCanceledOrders';
          break;
        case 'canceled':
          req.bucket = 'cancelledOrders';
          break;

        default:
          req.bucket = 'submittedOrders';
          break;
      }
    } else {
      if (statusRange.toLowerCase() === 'accepted') {
        statusRange = 'Processing'
      }
      if (statusRange.toLowerCase() === 'canceled') {
        statusRange = 'CANCELED'
      }
      req.bucket = orderType;
      req.range = statusRange;
    }

    return req;
  }

  centeredMetric(e) {
    let centerX = e.centerX;
    let centerY = e.centerY;
    return (
      <>
        <text
          x={centerX}
          y={centerY}
          textAnchor="middle"
          dominantBaseline="central"
          style={{
            fontSize: '18px',
            fontWeight: 'bold',
            textAlign: 'center'
          }}
        >
          {this.props.data.size ? (<tspan>{fmCompactNum(this.props.data.size)}</tspan>) : null}
        </text>
      </>
    )
  }

  render() {
    let loading = this.state.loading;
    if (loading) {
      return (<Loading size='S' />);
    } else {
      return (
        <div className="chart">
          <span className='chart-title'>{this.props.title ? this.props.title : ''}</span>
          <figure style={{ fontFamily: "'HPSimplified', Arial, Helvetica, sans-serif", fontSize: '16px' }}>
            <ResponsivePie
              data={this.state.chartData}
              margin={{ top: 10, right: 10, bottom: 10, left: 120 }}
              innerRadius={0.44}
              padAngle={2.4}
              cornerRadius={1}
              activeOuterRadiusOffset={6}
              borderWidth={1}
              colors={this.state.colors}
              borderColor={{ from: 'color', modifiers: [['darker', 0]] }}
              enableArcLabels={false}
              enableArcLinkLabels={false}
              legends={this.state.legendStyle}
              layers={[this.centeredMetric, 'arcs', 'arcLabels', 'arcLinkLabels', 'legends']}
            />
          </figure>
        </div>
      )
    }
  }
}


class DashboardRow extends React.Component {

  constructor(props) {
    super(props);
    this.drill = this.drill.bind(this);
    this.doDownload = this.doDownload.bind(this);
  }

  isCarepackDashboardRow(orderType) {
    const regex = /(.*openBlockedServices|.*registrationErrors|.*deRegisteredServices|.*registeredServices|.*serviceExpiration|.*canceledServices)/;
    return regex.test(orderType);
  }

  drill(bucket, range) {

    return function (e) {

      var searchId = $("#searchId").val();
      var dateSelection = $("#date_selection").val();
      var dateRange = $("#daterange").val();

      state.showDashboardTab = true;

      highlightBucket(bucket, range);

      $("#daterange").css({
        background: "#ffffff",
        border: "1px solid #ccc"
      });

      $("#date_selection").css({
        background: "#ffffff",
        border: "1px solid #ccc"
      });

      $("#resultMsg").html("");

      $("#resultMsg").removeClass("alert alert-danger info-alert");

      var params = {};
      var searchQry = {};

      params.orderLevelOutputmode = UserSettings.fields.order.orderLevelOutputmode;
      params.itemLevelExactMatch = UserSettings.fields.order.itemLevelExactMatch;
      params.bucket = bucket;
      params.range = range;
      searchQry.bucket = bucket;
      searchQry.range = range;

      // force grid to unmount, to later create fresh with data          
      ReactDOM.render(
        <OSLandingPage size={"large"} type={"dashboard"} hideGrid={true} searchQry={searchQry} />,
        document.getElementById('mainbody')
      );

      if (this.isCarepackDashboardRow(bucket)) {
        params.tab   = "cp";
        params.alert = bucket;
        params.lons  = this.props.data.lons;
      }

      POST("/os/ossui/v1/ex/externalDrilldown", params, function (result) {
        var subscreen = null;
        if (result.data.hasOwnProperty('subscreen')) {
          subscreen       = result.data.subscreen;
          state.subscreen = result.data.subscreen;
        }
        state.order = result;
        state.searchQry = searchQry;
        state.type = "dashboard";
        state.withPrices = result.withPrices;
        $('#ossOrderModal').modal('hide');
        ReactDOM.render(
          <ModalWidgetWaiting
            size={"large"} />
          , document.getElementById('externalWidget')
        );
        if (result.data.rows.length >= 1) {
          if (result.status == 'B') {
            $("#resultMsgOrder").html(T("Only first 2000 orders are shown"));
            $("#resultMsgOrder").addClass("info-alert");//alert();
            $("#resultMsgOrder").show();
          } else {
            $("#resultMsgOrder").hide();
          }
          var landingPage =
            ReactDOM.render(
              <OSLandingPage size={"large"} type={"dashboard"} subscreen={subscreen} order={result} hideGrid={false} searchQry={searchQry} />,
              document.getElementById('mainbody')
            );
          highlightBucket(bucket, range);

        } else if (result.data.rows.length == 1111) {

          var Params = {
            lookupType: "legacy_order_no",
            lookupValue: result.data.rows[0].legacy_order_no,
            callingSystem: 'quicksearch'
          }
          ReactDOM.render(
            <ModalWidgetWaiting
              size={"large"} />
            , document.getElementById('externalWidget')
          );
          $('#ossOrderModal').modal({ backdrop: 'static' });
          GET("/os/ossui/v1/ex/widget/order", Params, function (resp) {

            if (resp.status == 'N') {
              $("#resultMsg").html(T(resp.message));
              $("#resultMsg").removeClass("info-alert");
              $("#resultMsg").addClass("alert alert-danger");//alert();
            } else {

              if (resp.session && resp.session != undefined) {
                console.log('setting session', resp.session);
                document.cookie = 'session=' + resp.session + '; path=/;'
              }

              $('#ossOrderModal').modal('hide');
              $("#orderSelectList").show();
              $("#exportToExcel").show();

              ReactDOM.render(
                <OSWidget
                  order={resp.data} />
                , document.getElementById('externalWidget')
              );

              $('#ossOrderModal').modal({ backdrop: 'static' });
            }
          });
        } else {
          ReactDOM.render(
            <OSLandingPage size={"large"} type={"search"} order={"order"} searchQry={searchQry} />,
            document.getElementById('mainbody')
          );
          if (result.status == 'B') {
            $("#resultMsg").html(T("warn_search_exeed_more_than") + " 2000. " + T("warn_no_search_result") + ". " + T("warn_refine_search"));
            $("#resultMsg").removeClass("alert alert-danger");
            $("#resultMsg").addClass("info-alert");
          } else {
            $("#resultMsg").html(T(result.message));
            $("#resultMsg").removeClass("info-alert");
            $("#resultMsg").addClass("alert alert-danger");
          }
        }
      });
    }.bind(this);
  }

  doDownload() {
    var params = new Object();
    params.alert = this.props.orderType;
    params.bucket = this.props.orderType;
    params.range = "cp_total";
    params.locale = I18N.locale;
    params.lons = this.props.data.lons;
  
    // Use axios/fetch api instead of our POST (which is used for API calls)
    axios.post('/os/ossui/v1/ex/externalDrilldownForExportCarepackDashboard/', params, { responseType: 'arraybuffer' })
      .then(response => {
        /// Get filename from contentDisposition header
        var fileName = 'downloadedFile.xls';
        const contentDisposition = response.headers['content-disposition'];
        if (contentDisposition) {
          const fileNameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          const matches = fileNameRegex.exec(contentDisposition);
          if (matches != null && matches[1]) {
            fileName = matches[1].replace(/['"]/g, '');
          }
        }
  
        const blob = new Blob([response.data], { type: 'application/octet-stream' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
  
        // Simulate a HTML Click
        link.click();
      })
      .catch(error => {
        console.error('Error downloading file:', error);
      });
  }

  render() {

    if ( this.isCarepackDashboardRow(this.props.orderType)) {

        let bucket = '';
        bucket = this.props.orderType;
        let data = this.props.data[bucket];
        let bucketDescription = T(data.bucketDescription);
        let redDescription = T(data.redDescription);
        let yellowDescription = T(data.yellowDescription);
        let greenDescription = T(data.greenDescription);
        var title = data.errTitle;

        var green = <span></span>;
        var yellow = <span></span>;
        var red = <span></span>;
        var totalO = <span></span>;

        var expLink = <a disabled><i className="glyphicon glyphicon-circle-arrow-down" style={{ "color": "#767676", "fontSize": "16px" }} /></a>

        if (data.status == "S") {
          if (data.total && data.total != 0) {
            totalO = <a onClick={this.drill(bucket, "cp_total")}>{data.total}</a>;
            if (data.total > exportExcelMaxLimit) {
              var maxLimitText = "Export Limit of " + exportExcelMaxLimit + " rows reached";
              var expLink = <a disabled title={maxLimitText}><i className="glyphicon glyphicon-circle-arrow-down" style={{ "color": "#767676", "fontSize": "16px" }} /></a>
            } else {
              var link = RewriteRESTURL("/os/ossui/v1/ex/externalDrilldownForExportCarepackDashboard/" + this.props.orderType + "/total/0/" + I18N.locale);
              var expLink = <span onClick={() => this.doDownload()} title="export" style={{ color: "#0096d6", fontSize: "16px", cursor: 'pointer'}}>
                              <i className="glyphicon glyphicon-circle-arrow-down"></i>
                            </span>
            }
          } else {
            totalO = "0";
          }
          if (data.green && data.green != 0) {
            green = <a onClick={this.drill(bucket, "cp_green")}>{data.green}</a>;
          } else {
            green = "0";
          }
          if (data.yellow && data.yellow != 0) {
            yellow = <a onClick={this.drill(bucket, "cp_yellow")}>{data.yellow}</a>;
          } else {
            yellow = "0";
          }
          if (data.red && data.red != 0) {
            red = <a onClick={this.drill(bucket, "cp_red")}>{data.red}</a>;
          } else {
            red = "0";
          }

        } else if (data.status == "E") {
          totalO  = "E";
          green   = "E";
          yellow  = "E";
          red     = "E";
        } else {
          totalO  = <img key={bucket + 'spin0'} src={spinning_small} height="12" width="12" style={{ margin: "0px" }} />;
          green   = <img key={bucket + 'spin1'} src={spinning_small} height="12" width="12" style={{ margin: "0px" }} />;
          yellow  = <img key={bucket + 'spin2'} src={spinning_small} height="12" width="12" style={{ margin: "0px" }} />;
          red     = <img key={bucket + 'spin3'} src={spinning_small} height="12" width="12" style={{ margin: "0px" }} />;
        }

        let addId = bucket.replace(/ +/g, '');

        if (bucket == "canceledServices") {
          red     ="";
          yellow  ="";
          green   ="";
        }

        return (
          <tr className='omtTable'>
            <td className='omtAlert'  title={bucketDescription} >{T(this.props.name)}</td>
            <td className='omtGreen'  width="10%" title={greenDescription}  id={'valCell_' + addId + 'green'}    ><div className='alignedLargeCell' >{green}</div></td>
            <td className='omtYellow' width="10%" title={yellowDescription} id={'valCell_' + addId + 'yellow'}   ><div className='alignedLargeCell' >{yellow}  </div></td>
            <td className='omtRed'    width="10%" title={redDescription}    id={'valCell_' + addId + 'red'}      ><div className='alignedLargeCell' >{red} </div></td>
            <td className='omtTotal'  width="10%" title={title}             id={'valCell_' + addId + 'totalO'}   ><div className='alignedXLargeCell'>{totalO} &nbsp; {expLink}</div></td>
          </tr>
        )
        
    }

    if (this.props.orderType === 'Total') {

      var totalO = <a onClick={this.drill("submittedOrders", "total")}>{this.props.data.submittedOrders.total}</a>;
      var submitted = <a onClick={this.drill("submitOrders", "total")}>{this.props.data.submitOrders.total}</a>;
      var accepted = <a onClick={this.drill("acceptedOrders", "total")}>{this.props.data.acceptedOrders.total}</a>;
      var production = <a onClick={this.drill("productionOrders", "total")}>{this.props.data.productionOrders.total}</a>;
      var shipped = <a onClick={this.drill("shippedOrders", "total")}>{this.props.data.shippedOrders.total}</a>;
      var delivered = <a onClick={this.drill("deliveredOrders", "total")}>{this.props.data.deliveredOrders.total}</a>;
      var shipmentCanceled = <a onClick={this.drill("shipmentCanceledOrders", "total")}>{this.props.data.shipmentCanceledOrders.total}</a>;
      var cancelled = <a onClick={this.drill("cancelledOrders", "total")}>{this.props.data.cancelledOrders.total}</a>;

      if (this.props.data.submittedOrders.total == 0) totalO = "0";
      if (this.props.data.submitOrders.total == 0) submitted = "0";
      if (this.props.data.acceptedOrders.total == 0) accepted = "0";
      if (this.props.data.productionOrders.total == 0) production = "0";
      if (this.props.data.shippedOrders.total == 0) shipped = "0";
      if (this.props.data.deliveredOrders.total == 0) delivered = "0";
      if (this.props.data.shipmentCanceledOrders.total == 0) shipmentCanceled = "0";
      if (this.props.data.cancelledOrders.total == 0) cancelled = "0";

      var link = RewriteRESTURL("/os/ossui/v1/ex/externalDrilldownForExportTitanium/submittedOrders/total/0/" + I18N.locale);
      if (this.props.data.submittedOrders.total != 0) {
        if (this.props.data.submittedOrders.total > exportExcelMaxLimit) {
          var maxLimitText = "Export Limit of " + exportExcelMaxLimit + " rows reached";
          var expLink = <a disabled title={maxLimitText}><i className="glyphicon glyphicon-circle-arrow-down" style={{ "color": "#767676", "fontSize": "16px" }} /></a>
        } else {
          var expLink = <a href={link} title="export"><i className="glyphicon glyphicon-circle-arrow-down" style={{ "color": "#0096d6", "fontSize": "16px" }} /></a>
        }
      } else {
        var expLink = <a disabled><i className="glyphicon glyphicon-circle-arrow-down" style={{ "color": "#767676", "fontSize": "16px" }} /></a>
      }

      if (this.props.data.submittedOrders.total == null) totalO = <span></span>;
      if (this.props.data.submitOrders.total == null) submitted = <span></span>;
      if (this.props.data.acceptedOrders.total == null) accepted = <span></span>;
      if (this.props.data.productionOrders.total == null) production = <span></span>;
      if (this.props.data.shippedOrders.total == null) shipped = <span></span>;
      if (this.props.data.deliveredOrders.total == null) delivered = <span></span>;
      if (this.props.data.shipmentCanceledOrders.total == null) shipmentCanceled = <span></span>;
      if (this.props.data.cancelledOrders.total == null) cancelled = <span></span>;


      return (
        <tr>
          <td>{T(this.props.name)}</td>

          <td width="10%" id="valCell_submitOrders"    ><div className='alignedLargeCell' >{submitted} </div></td>
          <td width="10%" id="valCell_acceptedOrders"  ><div className='alignedLargeCell' >{accepted}  </div></td>
          <td width="10%" id="valCell_productionOrders"><div className='alignedLargeCell' >{production}</div></td>
          <td width="10%" id="valCell_shippedOrders"   ><div className='alignedLargeCell' >{shipped}   </div></td>
          <td width="10%" id="valCell_deliveredOrders" ><div className='alignedLargeCell' >{delivered} </div></td>
          <td width="10%" id="valCell_shipmentCanceledOrders" ><div className='alignedLargeCell' >{shipmentCanceled} </div></td>
          <td width="10%" id="valCell_cancelledOrders" ><div className='alignedLargeCell' >{cancelled} </div></td>

          <td width="10%" id="valCell_submittedOrders" ><div className='alignedXLargeCell'>{totalO} &nbsp; {expLink}</div></td>
        </tr>
      )
    } else {

      let bucket = '';
      if (this.props.orderType === 'Trade Order' || this.props.orderType === 'Claim Order' || this.props.orderType === 'Contract Order') {

        bucket = this.props.orderType;
        let data = this.props.data[bucket];

        var totalO = <span></span>;
        var submitted = <span></span>;
        var accepted = <span></span>;
        var production = <span></span>;
        var shipped = <span></span>;
        var delivered = <span></span>;
        var shipmentCanceled = <span></span>;
        var cancelled = <span></span>;

        var expLink = <a disabled><i className="glyphicon glyphicon-circle-arrow-down" style={{ "color": "#767676", "fontSize": "16px" }} /></a>

        if (data) {
          if (data.total) {
            totalO = <a onClick={this.drill(bucket, "total")}>{data.total}</a>;
            if (data.total > exportExcelMaxLimit) {
              var maxLimitText = "Export Limit of " + exportExcelMaxLimit + " rows reached";
              var expLink = <a disabled title={maxLimitText}><i className="glyphicon glyphicon-circle-arrow-down" style={{ "color": "#767676", "fontSize": "16px" }} /></a>
            } else {
              var link = RewriteRESTURL("/os/ossui/v1/ex/externalDrilldownForExportTitanium/" + this.props.orderType + "/total/0/" + I18N.locale);
              var expLink = <a href={link} title="export"><i className="glyphicon glyphicon-circle-arrow-down" style={{ "color": "#0096d6", "fontSize": "16px" }} /></a>
            }
          } else {
            totalO = "0";
          }
          if (data.Submitted) {
            submitted = <a onClick={this.drill(bucket, "Submitted")}>{data.Submitted}</a>;
          } else {
            submitted = "0";
          }
          if (data.Processing) {
            accepted = <a onClick={this.drill(bucket, "Processing")}>{data.Processing}</a>;
          } else {
            accepted = "0";
          }
          if (data.Production) {
            production = <a onClick={this.drill(bucket, "Production")}>{data.Production}</a>;
          } else {
            production = "0";
          }
          if (data.Shipped) {
            shipped = <a onClick={this.drill(bucket, "Shipped")}>{data.Shipped}</a>;
          } else {
            shipped = "0";
          }
          if (data.Delivered) {
            delivered = <a onClick={this.drill(bucket, "Delivered")}>{data.Delivered}</a>;
          } else {
            delivered = "0";
          }
          if (data.ShipmentCanceled) {
            shipmentCanceled = <a onClick={this.drill(bucket, "ShipmentCanceled")}>{data.ShipmentCanceled}</a>;
          } else {
            shipmentCanceled = "0";
          }
          if (data.CANCELED) {
            cancelled = <a onClick={this.drill(bucket, "CANCELED")}>{data.CANCELED}</a>;
          } else {
            cancelled = "0";
          }

        } else {
          totalO = "0";
          submitted = "0";
          accepted = "0";
          production = "0";
          shipped = "0";
          delivered = "0";
          shipmentCanceled = "0";
          cancelled = "0";
        }

        let addId = bucket.replace(/ +/g, '');

        return (
          <tr>
            <td>{T(this.props.name)}</td>

            <td width="10%" id={'valCell_' + addId + 'submitOrders'}    ><div className='alignedLargeCell' >{submitted} </div></td>
            <td width="10%" id={'valCell_' + addId + 'acceptedOrders'}  ><div className='alignedLargeCell' >{accepted}  </div></td>
            <td width="10%" id={'valCell_' + addId + 'productionOrders'}><div className='alignedLargeCell' >{production}</div></td>
            <td width="10%" id={'valCell_' + addId + 'shippedOrders'}   ><div className='alignedLargeCell' >{shipped}   </div></td>
            <td width="10%" id={'valCell_' + addId + 'deliveredOrders'} ><div className='alignedLargeCell' >{delivered} </div></td>
            <td width="10%" id={'valCell_' + addId + 'shipmentCanceledOrders'} ><div className='alignedLargeCell' >{shipmentCanceled} </div></td>
            <td width="10%" id={'valCell_' + addId + 'cancelledOrders'} ><div className='alignedLargeCell' >{cancelled} </div></td>

            <td width="10%" id={'valCell_' + addId + 'submittedOrders'} ><div className='alignedXLargeCell'>{totalO} &nbsp; {expLink}</div></td>
          </tr>
        )

      }
    }
  }
};

//----------------------------------------------------------------------
//   MyLastOrders
//
//----------------------------------------------------------------------
class MyLastOrders extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      dmfiPending: '',
      dmfiShipped: '',
      lastOrderData: {
        lastOrdersViewed: { total: null, all: null },
        lastOrdersPlaced: { total: null, all: null },
        lastOrdersShipped: { total: null, all: null },
        dmfiPending: { total: null, all: null },
        dmfiShipped: { total: null, all: null }
      }
    };
    window.myLastOrdersInstance = this; // Expose globally
    this.drill = this.drill.bind(this);
    this.drillDMFI = this.drillDMFI.bind(this);
    this.resetDisplayTable = this.resetDisplayTable.bind(this);
    this.getCount = this.getCount.bind(this);
  }

  drill(bucket, range) {

    return function (e) {

      this.resetDisplayTable();

      var searchId = $("#searchId").val();
      var dateSelection = $("#date_selection").val();
      var dateRange = $("#daterange").val();

      highlightBucket(bucket, range);

      $("#daterange").css({
        background: "#ffffff",
        border: "1px solid #ccc"
      });

      $("#date_selection").css({
        background: "#ffffff",
        border: "1px solid #ccc"
      });

      $("#resultMsg").html("");

      $("#resultMsg").removeClass("alert alert-danger info-alert");

      var params = {};
      var searchQry = {};

      params.bucket = bucket;
      params.range = range;
      searchQry.bucket = bucket;
      searchQry.range = range;

      // force grid to unmount, to later create fresh with data   
      ReactDOM.render(
        <OSLandingPage size={"large"} type={"dashboard"} hideGrid={true} searchQry={searchQry} />,
        document.getElementById('mainbody')
      );

      POST("/os/ossui/v1/ex/externalDrilldownLastOrders", params, function (result) {
        state.order = result;
        state.searchQry = searchQry;
        state.type = "dashboard";
        $('#ossOrderModal').modal('hide');
        ReactDOM.render(
          <ModalWidgetWaiting
            size={"large"} />
          , document.getElementById('externalWidget')
        );
        if (result.data.rows.length > 1) {
          ReactDOM.render(
            <OSLandingPage size={"large"} type={"dashboard"} subscreen={"header"} order={result} searchQry={searchQry} />,
            document.getElementById('mainbody')
          );
          $("#orderSelectList").show();
          $("#exportToExcel").show();
        } else if (result.data.rows.length == 1) {

          var Params = {
            lookupType: "legacy_order_no",
            lookupValue: result.data.rows[0].legacy_order_no,
            callingSystem: 'quicksearch'
          }
          ReactDOM.render(
            <ModalWidgetWaiting
              size={"large"} />
            , document.getElementById('externalWidget')
          );
          $('#ossOrderModal').modal({ backdrop: 'static' });
          GET("/os/ossui/v1/ex/widget/order", Params, function (resp) {

            if (resp.status == 'N') {
              $("#resultMsg").html(T(resp.message));
              $("#resultMsg").addClass("alert alert-danger");//alert();
            } else {

              $('#ossOrderModal').modal('hide');
              $("#orderSelectList").show();
              $("#exportToExcel").show();

              $("#resultMsgOrder").html("");
              $("#resultMsgOrder").removeClass("alert alert-danger");

              ReactDOM.render(
                <OSWidget
                  order={resp.data} />
                , document.getElementById('externalWidget')
              );

              $('#ossOrderModal').modal({ backdrop: 'static' });
            }
          });
        } else {
          ReactDOM.render(
            <OSLandingPage size={"large"} type={"search"} order={"order"} subscreen={"header"} searchQry={searchQry} />,
            document.getElementById('mainbody')
          );
          $("#resultMsgOrder").html(T("No " + bucket + " order available"));
          $("#resultMsgOrder").addClass("alert alert-danger");
          $("#orderSelectList").hide();
          $("#exportToExcel").hide();
          $("#backButton").hide();
        }
      });
    }.bind(this);
  }

  drillDMFI(bucket, range) {
    return function (e) {
      this.resetDisplayTable();
      var searchId = $("#searchId").val();
      var dateSelection = $("#date_selection").val();
      var dateRange = $("#daterange").val();

      //  highlightBucket(bucket);

      $("#daterange").css({
        background: "#ffffff",
        border: "1px solid #ccc"
      });

      $("#date_selection").css({
        background: "#ffffff",
        border: "1px solid #ccc"
      });

      $("#resultMsg").html("");

      $("#resultMsg").removeClass("alert alert-danger");

      var params = {};
      var searchQry = {};
      var result = {};
      var dmfiStatus = "";

      params.bucket = bucket;
      params.range = range;
      searchQry.bucket = bucket;
      searchQry.range = range;

      if (bucket == "dmfiPending")
        dmfiStatus = "Y";
      else
        dmfiStatus = "S";

      ReactDOM.render(
        <OSLandingPage size={"large"} type={"dashboard"} hideGrid={true} searchQry={searchQry} dmfiPending={dmfiStatus} />,
        document.getElementById('mainbody')
      );

      POST("/os/ossui/v1/ex/externalDrilldownLastOrders", params, function (result) {
        state.order = result;
        state.searchQry = searchQry;
        state.type = "dashboard";
        $('#ossOrderModal').modal('hide');
        ReactDOM.render(
          <ModalWidgetWaiting
            size={"large"} />
          , document.getElementById('externalWidget')
        );
        if (result.data.rows.length >= 1) {
          ReactDOM.render(
            <OSLandingPage size={"large"} type={"dashboard"} subscreen={"header"} order={result} searchQry={searchQry} dmfiPending={dmfiStatus} />,
            document.getElementById('mainbody')
          );
          $("#orderSelectList").show();
          $("#exportToExcel").show();
        } else {
          ReactDOM.render(
            <OSLandingPage size={"large"} type={"search"} order={"order"} subscreen={"header"} searchQry={searchQry} dmfiPending={dmfiStatus} />,
            document.getElementById('mainbody')
          );
          $("#resultMsgOrder").html(T("No " + bucket + " order available"));
          $("#resultMsgOrder").addClass("alert alert-danger");
          $("#orderSelectList").hide();
          $("#exportToExcel").hide();
          $("#backButton").hide();
        }
      });
    }.bind(this);
  }

  resetDisplayTable() {
    //console.log("Hiding data");
    $("#orderSelectList").hide();
    $("#exportToExcel").hide();
    $("#backButton").hide();
    $("#resultMsgOrder").hide();

    //if ($('#searchResultTab').hasClass("active")) {
      //ToDo GEGA we need to set the type correctly
      //self.state.searchQry.type = "searchresult";
    //}

  }

  async getCount(bucketVal) {
    var resultLen = 0;
    try {
      var result = await axios.post("/os/ossui/v1/ex/externalDrilldownLastOrders", { bucket: bucketVal, range: 'all' });
      resultLen = result.data.data.rows.length;
    } catch (err) {
      // Handle Error Here
      console.error(err);
    }
    if (bucketVal == "dmfiShipped")
      this.setState({ dmfiShipped: resultLen });
    else
      this.setState({ dmfiPending: resultLen });
  }


  componentDidMount() {
    this.drill("lastOrdersViewed", "all");
    if (UserSettings.isDMFIUser) {
      this.getCount("dmfiPending");
      this.getCount("dmfiShipped");
    }
  }

  render() {

    var self = this;
    var viewed = <a id="lastOrdersViewed" style={{ "color": "#ffffff", "fontWeight": "bold", "padding": "0px 2px 0px 4px", "cursor": "pointer" }} onClick={self.drill("lastOrdersViewed", "all")}>{T('LastOrdersViewed')} </a>;
    var placed = <a id="lastOrdersPlaced" style={{ "color": "#ffffff", "fontWeight": "bold", "padding": "0px 2px 0px 4px", "cursor": "pointer" }} onClick={self.drill("lastOrdersPlaced", "all")}>{T('LastOrdersPlaced')} </a>;
    var shipped = <a id="lastOrdersShipped" style={{ "color": "#ffffff", "fontWeight": "bold", "padding": "0px 2px 0px 4px", "cursor": "pointer" }} onClick={self.drill("lastOrdersShipped", "all")}>{T('LastOrdersShipped')} </a>;
    var dmfipndg = <a id="dmfiPending" style={{ "color": "#ffffff", "fontWeight": "bold", "padding": "0px 2px 0px 4px", "cursor": "pointer" }} onClick={self.drillDMFI("dmfiPending", "all")}>{T('DMFIPending')} </a>;
    var dmfiship = <a id="dmfiShipped" style={{ "color": "#ffffff", "fontWeight": "bold", "padding": "0px 2px 0px 4px", "cursor": "pointer" }} onClick={self.drillDMFI("dmfiShipped", "all")}>{T('DMFIShipped')} </a>;

    console.log(UserSettings);
    console.log(UserSettings.isDMFIUser);

    var dmfiMode = UserSettings.isDMFIUser;

    return (
      <div>
        <TabBar id="osWidgetSummaryHeader">
          <Tab active id="dashboardTab" name="dashboardTab" label={T('Dashboard')} onClick={self.resetDisplayTable}>
            <MyDashboard />
            <div id="resultMsgDashboard"></div>
          </Tab>;
          <Tab id="lastOrdersViewed" name="lastOrdersViewed" label={T('LastOrdersViewed')} onClick={self.drill("lastOrdersViewed", "all")}>
            <div id="resultMsgViewed"></div>
          </Tab>
          <Tab id="lastOrdersPlaced" name="lastOrdersPlaced" label={T('LastOrdersPlaced')} onClick={self.drill("lastOrdersPlaced", "all")}>
            <div id="resultMsgPlaced"></div>
          </Tab>
          <Tab id="lastOrdersShipped" name="lastOrdersShipped" label={T('LastOrdersShipped')} onClick={self.drill("lastOrdersShipped", "all")}>
            <div id="resultMsgShipped"></div>
          </Tab>
          <Tab id="searchResultTab" ref="searchResultTab" name="searchResultTab" label={T('Search Result')} onClick={self.resetDisplayTable}>
            <div id="resultMsgSearch"></div>
          </Tab>;
          {dmfiMode &&
            <Tab id="dmfiPendingTab" ref="dmfiPendingTab" name="dmfiPendingTab" label={T('DMFI Pending')} onClick={self.drillDMFI("dmfiPending", "all")} badgeColor="red" amount={this.state.dmfiPending}>
              <div id="resultMsgDmfiPending"></div>
            </Tab>
          }
          {dmfiMode &&
            <Tab id="dmfiShippedTab" ref="dmfiShippedTab" name="dmfiShippedTab" label={T('DMFI Shipped')} onClick={self.drillDMFI("dmfiShipped", "all")} badgeColor="red" amount={this.state.dmfiShipped}>
              <div id="resultMsgDmfiShipped"></div>
            </Tab>
          }
        </TabBar>
        <div id="resultMsgOrder"></div>
      </div>
    )
  }

};

class ArchiveGlyphicon extends React.Component {
  render() {
    const clickable = ["oss-itg.hpcloud.hp.com", "orderstatus-itg.hpcloud.hp.com", "oss.hpcloud.hp.com", "orderstatus.hpcloud.hp.com"].includes(window.location.host);
    const { active, onClick } = this.props;
    const color = active ? 'green' : 'grey';
    const cursorStyle = clickable ? 'pointer' : 'not-allowed';
    return (
      <span title="Include Archive Data" onClick={clickable ? onClick : null} style={{ cursor: cursorStyle }}>
        <i className="glyphicon glyphicon-hdd" style={{ color: color }}></i>
      </span>
    );
  }
}

class CarepackDashboard extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      dashboardData: {
        cp_registrationErrors:     { total: null, green: null, yellow: null, red: null, status: 'L' },
        cp_openBlockedServices:    { total: null, green: null, yellow: null, red: null, status: 'L' },
        cp_deRegisteredServices:   { total: null, green: null, yellow: null, red: null, status: 'L' },
        cp_registeredServices:     { total: null, green: null, yellow: null, red: null, status: 'L' },
        cp_serviceExpiration:      { total: null, green: null, yellow: null, red: null, status: 'L' },
        cp_canceledServices:       { total: null, green: null, yellow: null, red: null, status: 'L' },
        poly_openBlockedServices:  { total: null, green: null, yellow: null, red: null, status: 'L' },
        poly_serviceExpiration:    { total: null, green: null, yellow: null, red: null, status: 'L' },
        poly_canceledServices:     { total: null, green: null, yellow: null, red: null, status: 'L' },
      },
      status: 'L',
      includeArch: false
    };
    this.refreshDashboard = this.refreshDashboard.bind(this);
    this.showAllOrdersDrillDown = this.showAllOrdersDrillDown.bind(this);
    this.handleError = this.handleError.bind(this);
    this.toggleIncludeArch = this.toggleIncludeArch.bind(this);
  }

  componentDidMount() {
    this.refreshDashboard(false);
  }

  componentDidUpdate(prevProps, prevState) {
    //if (!this.arraysEqual(prevProps.preSearchLons, this.props.preSearchLons)) {
    //  this.refreshDashboard();
    //}
  }

  toggleIncludeArch() {
    this.setState(prevState => ({
      includeArch: !prevState.includeArch
    }));
    this.refreshDashboard(false)
  }

  arraysEqual(arr1, arr2) {
    // Check if the arrays have the same length
    if (arr1.length !== arr2.length) {
      return false;
    }
    // Check if each element in the arrays is equal
    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) {
        return false;
      }
    }
    return true;
  }

  showAllOrdersDrillDown() {
    console.log("dummy");
  }

  handleError(errcb, responseError, responseText, params) {
    var errTitle;
    if (responseError.hasOwnProperty("message") && responseError.message != "") {
      errTitle = responseError.message;
    } else {
      errTitle = errcb;
    }
    this.setState(prevState => ({
      dashboardData: {
        ...prevState.dashboardData,
        [params.alert]: {status: "E", errTitle: errTitle}
      },
      status: "S"
    }));
  }

  refreshDashboard(reset) {
    var self = this;
    var lons = Array.isArray(this.props.preSearchLons) ? this.props.preSearchLons : [];

    this.setState((prevState) => ({
      dashboardData: {
        cp_registrationErrors:     { total: null, green: null, yellow: null, red: null, status: 'L' },
        cp_openBlockedServices:    { total: null, green: null, yellow: null, red: null, status: 'L' },
        cp_deRegisteredServices:   { total: null, green: null, yellow: null, red: null, status: 'L' },
        cp_registeredServices:     { total: null, green: null, yellow: null, red: null, status: 'L' },
        cp_serviceExpiration:      { total: null, green: null, yellow: null, red: null, status: 'L' },
        cp_canceledServices:       { total: null, green: null, yellow: null, red: null, status: 'L' },
        poly_openBlockedServices:  { total: null, green: null, yellow: null, red: null, status: 'L' },
        poly_serviceExpiration:    { total: null, green: null, yellow: null, red: null, status: 'L' },
        poly_canceledServices:     { total: null, green: null, yellow: null, red: null, status: 'L' },
      }
    }), () => {
      Object.keys(this.state.dashboardData).forEach(alert => {
        var params = new Object();
        if (lons.length > 0 && !reset) {
          params.lons = lons;
          params.tab = "cp";
          params.alert = alert;
          POST("/os/ossui/v1/ex/widget/dashboardWithLons", params, function (resp) {
            if (resp.status == "S") {
              this.setState(prevState => ({
                dashboardData: {
                  ...prevState.dashboardData,
                  [resp.data.name]: resp.data,
                  lons:lons
                }
              }));
            }
            this.setState({ status: resp.status }) 
          }.bind(this), this.handleError.bind(this));

        } else {
          params.tab = "cp";
          params.alert = alert;
          GETwithTimeout("/os/ossui/v1/ex/widget/dashboard", params, 410000, function (resp) {
            if (resp.status == "S") {
              this.setState(prevState => ({
                dashboardData: {
                  ...prevState.dashboardData,
                  [resp.data.name]: resp.data
                }
              }));
            }
            this.setState({ status: resp.status }) 
          }.bind(this), this.handleError.bind(this));
          
          if (this.state.includeArch) {
            params = new Object();
            params.tab = "cp";
            params.alert = alert;
            params.queryOSSDBArch = true;
            GETwithTimeout("/os/ossui/v1/ex/widget/dashboard", params, 410000, function (resp) {
              if (resp.status == "S") {
                this.setState(prevState => ({
                  dashboardData: {
                    ...prevState.dashboardData,
                    [resp.data.name]: resp.data
                  }
                }));
              }
              //this.setState({ status: resp.status }) 
            }.bind(this), this.handleError.bind(this));
          }
        }
      });
    });

  }

  render() {
    var dashboardData = this.state.dashboardData;
    var highestTotalKey = null;
    var highestTotalValue = -Infinity;
    
    for (const key in dashboardData) {
        const total = dashboardData[key].total;
        
        if (total !== null && total > highestTotalValue) {
            highestTotalValue = total;
            highestTotalKey = key;
        }
    }
    
    var grandTotal = highestTotalKey ? dashboardData[highestTotalKey] : null;
    var showAllOrders = <noscript />
    var exportAllExcel = RewriteRESTURL("/os/ossui/v1/ex/externalDrilldownForExportTitanium/submittedOrders/total/1/" + I18N.locale);

    // set user information into state
    state.accountname = dashboardData.accountname;
    state.firstname = dashboardData.firstname;
    state.lastname = dashboardData.lastname;

    if (grandTotal > 0 && grandTotal <= showAllOrdersMaxLimit) {
      showAllOrders =
        (
          <div style={{ "marginTop": "-15px", "textAlign": "right", "fontSize": "16px" }}>
            <a className="btn btn-primary btn-sm" title="Export all orders" style={{ "color": "#fff" }} href={exportAllExcel}>&nbsp;<i className="glyphicon glyphicon-circle-arrow-down" />&nbsp;</a>&nbsp;&nbsp;
            <a className="btn btn-primary btn-sm" title="Show all orders" onClick={() => this.showAllOrdersDrillDown()}>{T('Show all orders')} </a>
          </div>
        )
    } else if (grandTotal == 0) {
      showAllOrders =
        (
          <div style={{ "marginTop": "-15px", "textAlign": "right", "fontSize": "16px" }}></div>
        )
    } else {
      if (grandTotal > exportExcelMaxLimit) {
        var maxLimitText = "Export Limit of " + exportExcelMaxLimit + " rows reached";
        showAllOrders =
          (
            <div style={{ "marginTop": "-15px", "textAlign": "right", "fontSize": "16px" }} title={maxLimitText}>
              <a className="btn btn-primary btn-sm" style={{ "color": "#767676" }} disabled>&nbsp;<i className="glyphicon glyphicon-circle-arrow-down" />&nbsp;</a>
            </div>
          );
      } else {
        showAllOrders =
          (
            <div style={{ "marginTop": "-15px", "textAlign": "right", "fontSize": "16px" }}>
              <a className="btn btn-primary btn-sm" title="Export all orders" style={{ "color": "#fff" }} href={exportAllExcel}>&nbsp;<i className="glyphicon glyphicon-circle-arrow-down" />&nbsp;</a>
            </div>
          );
      }
    }
    //console.log(showAllOrderCnt);
     
    return (
      <div>
        <table className="table dashboard-tab">
          <thead>
            <tr>
              <th>{T('alert_bucket')}</th>
              <th colspan="3">{T('traffic_light')}</th>
              <th id="total"> {T('Total')}</th>
            </tr>
          </thead>
          <tbody>
            <DashboardRow name='Care Pack - Open Blocked Services'       data={dashboardData} orderType='cp_openBlockedServices' />
            <DashboardRow name='Care Pack - Service Registration Errors' data={dashboardData} orderType='cp_registrationErrors' />
            <DashboardRow name='Care Pack - Not Registered Services'     data={dashboardData} orderType='cp_deRegisteredServices' />
            <DashboardRow name='Care Pack - Registered Services'         data={dashboardData} orderType='cp_registeredServices' />
            <DashboardRow name='Care Pack - Expiring Services'           data={dashboardData} orderType='cp_serviceExpiration' />
            <DashboardRow name='Care Pack - Canceled Services'           data={dashboardData} orderType='cp_canceledServices' />
            <tr className='omtSeparatorRow'><td colSpan="5"></td></tr>
            <DashboardRow name='Poly - Open Blocked Services'            data={dashboardData} orderType='poly_openBlockedServices' />
            <DashboardRow name='Poly - Expiring Services'                data={dashboardData} orderType='poly_serviceExpiration' />
            <DashboardRow name='Poly - Canceled Services'                data={dashboardData} orderType='poly_canceledServices' />

          </tbody>
          <tfoot>
            <tr>
              <td></td>
              <td></td>
              <td colSpan={1}>
                <span onClick={() => this.refreshDashboard(false)} title="Reload from filters" style={{ cursor: 'pointer' }}>
                  <i className="glyphicon glyphicon-refresh"></i>
                </span>
              </td>
              <td colSpan={1}>
                <span onClick={() => this.refreshDashboard(true)} title="Reset View" style={{ cursor: 'pointer' }}>
                  <i className="glyphicon glyphicon-repeat"></i>
                </span>
              </td>
              <td colSpan={1}>
                <ArchiveGlyphicon active={this.state.includeArch} onClick={this.toggleIncludeArch} />
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    )
  }

};

//----------------------------------------------------------------------
//   MyDashboard
//
//----------------------------------------------------------------------
class MyDashboard extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      dashboardData: {
        submitOrders: { total: null, range1: null, range2: null, range3: null },
        submittedOrders: { total: null, range1: null, range2: null, range3: null },
        openOrders: { total: null, range1: null, range2: null, range3: null },
        acceptedOrders: { total: null, range1: null, range2: null, range3: null },
        productionOrders: { total: null, range1: null, range2: null, range3: null },
        shippedOrDelvOrders: { total: null, range1: null, range2: null, range3: null },
        shippedOrders: { total: null, range1: null, range2: null, range3: null },
        deliveredOrders: { total: null, range1: null, range2: null, range3: null },
        shipmentCanceledOrders: { total: null, range1: null, range2: null, range3: null },
        cancelledOrders: { total: null, range1: null, range2: null, range3: null },
        outstandingPODOrders: { total: null, range1: null, range2: null, range3: null },
        outstandingInvOrders: { total: null, range1: null, range2: null, range3: null },
        delayedInvOrders: { total: null, range1: null, range2: null, range3: null }
      },
      status: 'L'
    };
    this.refreshDashboard = this.refreshDashboard.bind(this);
    this.showAllOrdersDrillDown = this.showAllOrdersDrillDown.bind(this);
    this.handleError = this.handleError.bind(this);
  }

  refreshDashboard() {
    var self = this;
    var params = {};

    GET("/os/ossui/v1/ex/widget/dashboard", params, function (resp) {
      if (resp.status == "S") {
        self.setState({ dashboardData: resp.data });
      }
      this.setState({ status: resp.status })

    }.bind(this), this.handleError);
  }

  handleError(statusText) {
    if (statusText == "error") {
      this.setState({ status: 'E' })

    } else if (statusText == "timeout") {
      this.setState({ status: 'T' })
    }
  }

  componentDidMount() {
    this.refreshDashboard();
  }

  showAllOrdersDrillDown() {
    return function (e) {

      var params = {};
      var searchQry = {};

      params.bucket = 'submittedOrders';
      params.range = 'total';
      searchQry.bucket = 'All Bucket';
      searchQry.range = 'ALL';
      $("#resultMsg").html("");
      $("#resultMsg").removeClass("alert alert-danger info-alert");

      //GEGA ToDo Use header/item data service ! add parameter for getResult
      POST("/os/ossui/v1/ex/externalDrilldown", params, function (result) {
        state.order = result;
        state.searchQry = searchQry;
        state.type = "dashboard";
        $('#ossOrderModal').modal('hide');
        ReactDOM.render(
          <ModalWidgetWaiting
            size={"large"} />
          , document.getElementById('mainbody')
        );

        if (result.data.rows.length > 1) {
          ReactDOM.render(
            <OSLandingPage size={"large"} type={"dashboard"} order={result} searchQry={searchQry} />,
            document.getElementById('mainbody')
          );
        } else if (result.data.rows.length == 1111) {

          var Params = {
            lookupType: "legacy_order_no",
            lookupValue: result.data.rows[0].legacy_order_no,
            callingSystem: 'quicksearch'
          }
          GET("/os/ossui/v1/ex/widget/order", Params, function (resp) {

            if (resp.status == 'N') {
              $("#resultMsg").html(T(resp.message));
              $("#resultMsg").removeClass("info-alert");
              $("#resultMsg").addClass("alert alert-danger");//alert();
            } else {

              $('#ossOrderModal').modal('hide');
              ReactDOM.render(
                <OSWidget
                  order={resp.data} />
                , document.getElementById('externalWidget')
              );

              $('#ossOrderModal').modal({ backdrop: 'static' });
            }
          });
        } else {
          ReactDOM.render(
            <OSLandingPage size={"large"} type={"search"} order={"order"} searchQry={searchQry} />,
            document.getElementById('mainbody')
          );
          if (result.status == 'B') {
            $("#resultMsg").html(T("warn_search_exeed_more_than") + " 2000. " + T("warn_no_search_result") + ". " + T("warn_refine_search"));
            $("#resultMsg").removeClass("alert alert-danger");
            $("#resultMsg").addClass("info-alert");
          } else {
            $("#resultMsg").html(T(result.message));
            $("#resultMsg").removeClass("info-alert");
            $("#resultMsg").addClass("alert alert-danger");
          }
        }
      });
    }.bind(this);
  }

  render() {
    var dashboardData = this.state.dashboardData;
    var grandTotal = dashboardData.submittedOrders.total;
    var showAllOrders = <noscript />
    var exportAllExcel = RewriteRESTURL("/os/ossui/v1/ex/externalDrilldownForExportTitanium/submittedOrders/total/1/" + I18N.locale);

    // set user information into state
    state.accountname = dashboardData.accountname;
    state.firstname = dashboardData.firstname;
    state.lastname = dashboardData.lastname;

    if (grandTotal > 0 && grandTotal <= showAllOrdersMaxLimit) {
      showAllOrders =
        (
          <div style={{ "marginTop": "-15px", "textAlign": "right", "fontSize": "16px" }}>
            <a className="btn btn-primary btn-sm" title="Export all orders" style={{ "color": "#fff" }} href={exportAllExcel}>&nbsp;<i className="glyphicon glyphicon-circle-arrow-down" />&nbsp;</a>&nbsp;&nbsp;
            <a className="btn btn-primary btn-sm" title="Show all orders" onClick={this.showAllOrdersDrillDown()}>{T('Show all orders')} </a>
          </div>
        )
    } else if (grandTotal == 0) {
      showAllOrders =
        (
          <div style={{ "marginTop": "-15px", "textAlign": "right", "fontSize": "16px" }}></div>
        )
    } else {
      if (grandTotal > exportExcelMaxLimit) {
        var maxLimitText = "Export Limit of " + exportExcelMaxLimit + " rows reached";
        showAllOrders =
          (
            <div style={{ "marginTop": "-15px", "textAlign": "right", "fontSize": "16px" }} title={maxLimitText}>
              <a className="btn btn-primary btn-sm" style={{ "color": "#767676" }} disabled>&nbsp;<i className="glyphicon glyphicon-circle-arrow-down" />&nbsp;</a>
            </div>
          );
      } else {
        showAllOrders =
          (
            <div style={{ "marginTop": "-15px", "textAlign": "right", "fontSize": "16px" }}>
              <a className="btn btn-primary btn-sm" title="Export all orders" style={{ "color": "#fff" }} href={exportAllExcel}>&nbsp;<i className="glyphicon glyphicon-circle-arrow-down" />&nbsp;</a>
            </div>
          );
      }
    }
    //console.log(showAllOrderCnt);

    if (this.state.status == 'S') {
      return (
        <div>
          <table className="table dashboard-tab">
            <thead>
              <tr>
                <th>{T('order_bucket')}</th>
                <th id="submitOrders" style={{textAlign: 'right'}}>{T('Submitted')}</th>
                <th id="acceptedOrders" style={{textAlign: 'right'}}>{T('Processing')}</th>
                <th id="productionOrders" style={{textAlign: 'right'}}>{T('Production')}</th>
                <th id="shippedOrders" style={{textAlign: 'right'}}>{T('Shipped')}</th>
                <th id="deliveredOrders" style={{textAlign: 'right'}}>{T('Delivered')}</th>
                <th id="shipmentCanceledOrders" style={{textAlign: 'right'}}>{T('ShipmentCanceled')}</th>
                <th id="cancelledOrders" style={{textAlign: 'right'}}>{T('Cancelled')}</th>
                <th id="submittedOrders" style={{textAlign: 'right'}}>{T('Total')}</th>
              </tr>
            </thead>
            <tbody>
              <DashboardRow name='Backlog - Trade Order' data={dashboardData} orderType='Trade Order' />
              <DashboardRow name='Backlog - Claim Order' data={dashboardData} orderType='Claim Order' />
              <DashboardRow name='Backlog - Contract Order' data={dashboardData} orderType='Contract Order' />
              <DashboardRow name='Backlog - Total' data={dashboardData} orderType='Total' />
            </tbody>
          </table>
          <div className="dashboard-chart-container">
            {this.state.dashboardData.submittedOrders.total != null ? <DashboardChartContainer data={this.state.dashboardData} /> : <Loading size='S' />}
          </div>
        </div>
      )
    } else {
      return (
        <BasicAlert type={this.state.status} />
      )
    }
  }
};

const TabBarNew = ({ children, onTabChange }) => {
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    setActiveTab(0); // Set the initial active tab index to 0
  }, []);

  const handleTabChange = (tabIndex) => {
    setActiveTab(tabIndex);
    onTabChange(tabIndex);
  };

  return (
    <div>
      <ul className="nav nav-tabs">
        {React.Children.map(children, (child, index) => (
          <li className={`nav-item ${activeTab === index ? 'active' : ''}`} key={index}>
            <button
              className={`nav-link ${activeTab === index ? 'active' : ''}`}
              data-toggle="tab"
              style={child.props.style}
              onClick={() => handleTabChange(index)}
            >
              {child.props.label}
            </button>
          </li>
        ))}
      </ul>
      <div className="tab-content">
        {React.Children.map(children, (child, index) => (
          <div
            className={`tab-pane ${activeTab === index ? 'active show' : ''} tab-content`}
            key={index}
          >
            {child}
          </div>
        ))}
      </div>
    </div>
  );
};

class CarepackDashboardAlerts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      "dashboardId": "2702",
      "cachedAlerts": {},
      "alertNumbersLoading": {},
      "profileId": 41622,
      "displayValues": "items",
      "adhocFilters": [],
      "filterMode": "no",
      "alertList": [],
      "drilldown": {
          "omtConditions": {}
      },
      "drilldownTplName": {},
      "drilldownExportExcelReq": {},
      "caller": "osExtDashboard",
      loadOMTFinished: false
    }
    this.loadOMTData = this.loadOMTData.bind(this);
    this.drillDownStateChange = this.drillDownStateChange.bind(this);
  }


  getCurrentAdhocFilters() {
    console.log("BMT_DEBUG getCurrentAdhocFilters");
  }
  eraseCachedAlerts() {
    console.log("BMT_DEBUG eraseCachedAlerts");
  }
  handleGetAndShowDashboard() {
    console.log("BMT_DEBUG handleGetAndShowDashboard");
  }
  handleFilterModeChange() {
    console.log("BMT_DEBUG handleFilterModeChange");
  }
  handleDisplayValueChange() {
    console.log("BMT_DEBUG handleDisplayValueChange");
  }
  drillDownStateChange(drilldown, drilldownData, loadingDrilldown, drilldownExportExcelReq) {
    console.log("BMT_DEBUG drillDownStateChange");
    var searchQry = {};

    ReactDOM.render(
      <OSLandingPage size={"large"} type={"searchresult"} hideGrid={true} searchQry={searchQry} />,
      document.getElementById('mainbody')
    );

    if (drilldownData) {
      console.log("BMT_DEBUG drilldown loading finished");

      var result = {
        data: {rows: drilldownData.rows, lons:[]}
        , status: "S"};

      ReactDOM.render(
        <OSLandingPage size={"large"} type={"searchresult"} subscreen='cp' order={result} searchQry={searchQry} />,
        document.getElementById('mainbody')
      );


    } else {
      console.log("BMT_DEBUG drilldown loading ...");
      this.setState(prevState => ({ 
        loadingDrilldown : loadingDrilldown,
      }))          
    }

  }
  toggleSeparator() {
    console.log("BMT_DEBUG toggleSeparator");
  }

  componentDidMount() {
    if (window.location.hostname == 'oss-qa.hpcloud.hp.com' ) {
      this.loadOMTData();
    }
  }

  loadOMTData() {
    var self          = this;
    var dashboardId   = this.state.dashboardId;
    var profileId     = this.state.profileId;
    var displayValues = this.state.displayValues;
    var dashboardAlertsInfoUrl = '/os/ossui/v1/in/alertDashboard/'+ dashboardId;

    GET(dashboardAlertsInfoUrl,'', function(response) {
     var alertListArray = []; // reset it and create empty array
     var separators = [];
      $.each( response.data.alerts ,function( key, val ) {

        if (val != null) {

         if (val.alert_id == '0') {

           separators.push({
             name            : val.alert_name,
             alert_id        : val.alert_id,
             separatorIndex  : val.dashboard_alert_ln,
             collapsed       : true
           });
           alertListArray.push({
             name            : val.alert_name,
             alert_id        : val.alert_id,
             collapsed       : true
           });
         } else {
           alertListArray.push( {
             name            : val.alert_name,
             alert_id        : val.alert_id,
             show            : true
           });
         }
         
        }
      });
      //console.log("GET alertListArray: ", alertListArray);

      let alertNumbersLoading = {};
      var alertRows = alertListArray.map(function(alert) {

        // OMT/dashboard values depend on this input:
        var omtConditions = {
          profile:       profileId,
          alert:         alert.alert_id,
          adhoc:         [],
          displayValues: displayValues
        }

        var cleanCondition = JSON.parse( JSON.stringify( omtConditions ) );
        var cleanConditionJSON = JSON.stringify(cleanCondition);
        alertNumbersLoading[cleanConditionJSON] = true;

        self.setState({
          alertNumbersLoading: alertNumbersLoading,
          alertList: alertListArray,
          separators: separators,
        })

        POST('/os/ossui/v1/in/omtNumbersAll', JSON.parse(cleanConditionJSON), function(resp) {
  
          var alertbucket = [];
          if(resp.data){
            let trigger = resp.data[0];
            let red     = resp.data[1];
            let yellow  = resp.data[3];
            let green   = resp.data[5];
            alertbucket.push(trigger,red,yellow,green)
          }
    
          if (resp.nrRows) {
              // hand over to AlertRow as nested array
            let nrRows = [];
            let nrRowTrigger = resp.nrRows[0];
            let nrRowRed     = resp.nrRows[1];
            let nrRowYellow  = resp.nrRows[3];
            let nrRowGreen   = resp.nrRows[5];
            nrRows.push(nrRowTrigger,nrRowRed,nrRowYellow,nrRowGreen);
            alertbucket[4] = nrRows; 
          }
    
          var cachedAlerts        = {...self.state.cachedAlerts        };
          var alertNumbersLoading = {...self.state.alertNumbersLoading }; 
    
          cachedAlerts       [ cleanConditionJSON ] = alertbucket;
          alertNumbersLoading[ cleanConditionJSON ] = false;
    
          self.setState({
            cachedAlerts:cachedAlerts,
            alertNumbersLoading: alertNumbersLoading,
            loadOMTFinished: true
          })
        });

      });
    });
  }


  render() {
    let orderSearch = this.state.orderSearch;

    if (this.state.loadOMTFinished) {
      return (
        <ShowAlerts //onChange={this.handleAdhocFilterChange} 
            dashboardId={this.state.dashboardId}
            cachedAlerts={this.state.cachedAlerts}
            eraseCachedAlerts={this.eraseCachedAlerts}
            getCurrentAdhocFilters={this.getCurrentAdhocFilters}
            getAndShowDashboard={this.handleGetAndShowDashboard}
            alertNumbersLoading={this.state.alertNumbersLoading}
            profileId={this.state.profileId}
            displayValues={this.state.displayValues}
            adhocFilters={this.state.adhocFilters}
            filterMode={this.state.filterMode}
            handleFilterModeChange={this.handleFilterModeChange}
            handleDisplayValueChange={this.handleDisplayValueChange}
            alertList={this.state.alertList}
            drillDownStateChange={this.drillDownStateChange}
            drilldown = {this.state.drilldown}
            drilldownTplName={this.state.drilldownTplName}
            drilldownExportExcelReq={this.state.drilldownExportExcelReq}
            handleToggleSeparator={this.toggleSeparator}/>
      )
    } else {
      return (
        <BasicAlert type="N" />
      )
    }
  }


};

//----------------------------------------------------------------------
//   OSLandingPage
//
//----------------------------------------------------------------------
export class OSLandingPage extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      orderSearch: true,
      notifications: [],
      status: 'L',
      activeTab: 0,
    }
    this.getNotifications = this.getNotifications.bind(this);
    //this.handleBack = this.handleBack.bind(this);
    this.handleExportToExcel = this.handleExportToExcel.bind(this);
    this.setOrderFilterData = this.setOrderFilterData.bind(this);
  }

  handleTabChange = (tabIndex) => {
    console.log("active tab change to: ", tabIndex);
    this.setState({ activeTab: tabIndex });
  };

  handleRowClick(rowObject) {
    //console.log( 'handleRowClick:', rowObject );   
    if (rowObject.legacy_order_no) {
      ShowOrderWidget(rowObject.legacy_order_no)
    }
  }

  handleExportToExcel() {

    var bucket = "All Bucket";
    var range = "ALL";
    var lons = "";
    if (typeof this.props.searchQry.bucket !== 'undefined' && typeof this.props.searchQry.range !== 'undefined') {
      bucket = this.props.searchQry.bucket;
      range = this.props.searchQry.range;
    }
    if (typeof state.lons !== 'undefined' && state.lons != "") {
      lons = state.lons;
    } else if (typeof this.props.order.data.lons !== 'undefined' && this.props.order.data.lons != "") {
      lons = this.props.order.data.lons;
    }

    if (this.props.type == "searchresult") {
      bucket = 'Search Result';
      var exportURL = RewriteRESTURL("/os/ossui/v1/ex/externalExportTitanium/" + this.props.searchQry.searchBy + "/" + I18N.locale);
    } else {
      var exportURL = RewriteRESTURL("/os/ossui/v1/ex/externalExportTitanium/H/" + I18N.locale);
    }

    $("#exportToExcelForm").attr('action', exportURL);
    $("#exportToExcelFormLons").val(lons);
    $("#exportToExcelFormBucket").val(bucket);
    $("#exportToExcelFormRange").val(range);
    $("#exportToExcelFormFirstname").val(state.firstname);
    $("#exportToExcelFormLastname").val(state.lastname);
    $("#exportToExcelFormAccountname").val(state.accountname);

    $("#spinningIcon").show();
    $("#exportToExcelForm").submit();
    $("#spinningIcon").hide();

  }

  downloadGridData() {
    var fileName = 'HPI_Export_Data_View.xlsx';
    var newtable = document.createElement('table');
    var content = "<thead><tr>";

    DrillDownColumns.map(function(colInfo) {
      content += "<td style='background-color: #0096d6; color: white'>" + colInfo.name + "</td>";
    });
    content += "</tr></thead><tbody>";

    DrillDownData.map(function(row) {
      content += "<tr>";
      DrillDownColumns.map(function(colInfo) {
        content += "<td>" + (row[colInfo.field] || "") + "</td>";
      });
      content += "</tr>";
    });
    content += "</tbody>";

    newtable.innerHTML = content;
    DownloadTableAsShownXLSX(newtable, fileName);
  }

  setOrderFilterData(rows) {
    const data = rows.map((row, i) => {
      const updateRow = {
        ...row,
        order_overall_status: OSWidgetLib.mapItemStatus(row.order_overall_status, row.tenant)
      };
      return updateRow;
    })
    return data;
  }

  getNotifications() {
    var self = this;

    GET("/os/ossui/v1/ex/notifications/lastweek", '', function (res) {
      if (res.status == 'S') {
        self.setState({ notifications: res.data })
        $('#svgCircle').css('display', 'none');
        $('#notificationBadge').text(res.data.length);
      }
      self.setState({ status: res.status })
    });
  }

  componentDidMount() {
    var urlParam = window.location.search;
    urlParam = urlParam.substring(1);

    if (urlParam === 'notifications') {
      this.setState({ orderSearch: false })
    }

    this.getNotifications();
  }

  render() {
    let orderSearch = this.state.orderSearch;

    if (orderSearch) {

      if (window.UserSettings && Object.keys(UserSettings).length == 0) {
        //console.log("overwrite UserSettings from window value")
        UserSettings = window.UserSettings;
      }

      var width = "995px";
      if (this.props.width) {
        width = this.props.width;
      }

      var showOrder = "";
      if (this.props.showOrder) {
        showOrder = this.props.showOrder;
      }

      if (typeof state == "undefined") {
        state = {}
      }
      state.fields = ["order_no", "purchase_order_no"];

      console.log("OSLandingPage this.props.type=====>");
      console.log(this.props.type);
      //console.log("showOrder: "+showOrder);
      var searchQry = "";
      var bucket = "";
      var range = "";
      if (typeof this.props.searchQry !== 'undefined') {
        if (typeof this.props.searchQry === 'object') {
          searchQry = this.props.searchQry;
        } else {
          var searchQry = {};
        }
        searchQry.type = this.props.type;
        bucket = this.props.searchQry.bucket;
        range = this.props.searchQry.range;
        if (typeof this.props.searchQry.bucket == 'undefined' && searchQry.type == 'searchresult') {
          $('#osWidgetSummaryHeader a[href="#searchResultTab"]').tab('show')
        }
      }
      //console.log("searchQry/bucket: "+JSON.stringify(searchQry)+"/"+bucket);

      highlightBucket(bucket, range);

      var order = null;
      var columns = null;
      var length = null;
      var lonsLength = null;
      if (typeof this.props.order !== 'undefined' && typeof this.props.order.data !== 'undefined') {
        order = this.setOrderFilterData(this.props.order.data.rows);
        columns = this.props.order.data.columns;
        length = this.props.order.data.rows.length;
        if (typeof this.props.order.data.lons !== 'undefined') {
          state.lons = this.props.order.data.lons;
          lonsLength = this.props.order.data.lons.length;
        }
      }
      const availableFields = new Set();
      if (Array.isArray(order)) {
        order.forEach(row => {
          if (!row || typeof row !== 'object') return;
          Object.keys(row).forEach(key => availableFields.add(key));
        });
      }
      const filterFieldsByAvailability = (fields) => {
        if (this.props.type != "searchresult" || availableFields.size === 0) {
          return fields;
        }
        const filtered = fields.filter(field => availableFields.has(field));
        return filtered.length > 0 ? filtered : fields;
      };

      var dataRangeStr = null;

      if (this.props.searchQry.dateRange != "") {
        dataRangeStr = this.props.searchQry.dateType + " ( " + this.props.searchQry.dateRange + " )";
      }

      var searchVal = this.props.searchQry.id;
      setTimeout(function () {
        $("#orderSelectList td").highlight(searchVal, 'highlighted');
        $("#orderSelectList td a").highlight(searchVal, 'highlighted');
      }, 100);

      var type = this.props.type;
      console.log('this.props.searchQry.bucket:' + this.props.searchQry.bucket);
      var bucket = this.props.searchQry.bucket;
      var searchBy = this.props.searchQry.searchBy;

      var exportToExcel = null;

      if (this.props.type == "dashboard" || this.props.type == "searchresult") {
        if (length <= exportExcelMaxLimit) {
          exportToExcel = (
            <div style={{ "background": "#0096d6", "minWidth": "30px", "padding": "4px 4px 5px 6px", "textAlign": "left" }}>
              <form name="exportToExcelForm" id="exportToExcelForm" method="post" style={{ "display": "none" }}>
                <input type="hidden" id="exportToExcelFormLons" name="lons"></input>
                <input type="hidden" id="exportToExcelFormBucket" name="bucket"></input>
                <input type="hidden" id="exportToExcelFormRange" name="range"></input>
                <input type="hidden" id="exportToExcelFormFirstname" name="firstname"></input>
                <input type="hidden" id="exportToExcelFormLastname" name="lastname"></input>
                <input type="hidden" id="exportToExcelFormAccountname" name="accountname"></input>
              </form>
              <div className="btn-group"><a href="#" data-toggle="dropdown" className="dropdown-toggle">
                <i className="glyphicon glyphicon-circle-arrow-down" style={{ "color": "#fff" }} />
              </a>
                <ul className="dropdown-menu">
                 {this.state.activeTab !== 2 && (
                    <li><a onClick={this.handleExportToExcel} style={{ "textDecoration": "none", "cursor": "pointer" }}>{T('Export Data by Pre-Defined Template')} </a></li>
                  )}
                  <li><a onClick={this.downloadGridData} style={{ "textDecoration": "none", "cursor": "pointer" }}>{T('Export Data as shown below')} </a></li>
                </ul>
              </div>
              {header}
            </div>
          )
        } else {
          var maxLimitText = "Export Limit of " + exportExcelMaxLimit + " rows reached";
          exportToExcel = (
            <div title={maxLimitText} style={{ "background": "#0096d6", "minWidth": "30px", "padding": "4px 4px 5px 6px", "textAlign": "left" }}>
              <a disabled style={{ "color": "#767676", "textDecoration": "none" }}>&nbsp;<i className="glyphicon glyphicon-circle-arrow-down" />&nbsp;</a>
              {header}
            </div>
          )
        }
      } else if (this.props.type != "default") {
        exportToExcel = (
          <div style={{ "background": "#0096d6", "minWidth": "30px", "padding": "4px 4px 5px 6px", "textAlign": "left" }}>
            {header}
          </div>
        )
      }


      var displayTable = null;
      if (this.props.type != "default") {
        if (this.props.searchQry && this.props.searchQry.searchBy && this.props.searchQry.searchBy == "D") {
        } else {
        }

        console.log(order);

        const forceCPSearchColumns = this.props.type == "searchresult" &&
          this.props.searchQry &&
          this.props.searchQry.searchBy == "CP";

        if (forceCPSearchColumns || this.props.subscreen == 'cp') {
          subscreen = 'cp';
          var drilldownColumns = filterFieldsByAvailability(UserSettings.fields.cp.choosen).map(function (f) {
            var label = f;
            for (var i = 0; i < UserSettings.fields.cp.all.length; i++) {
              if (UserSettings.fields.cp.all[i].field == f) {
                label = UserSettings.fields.cp.all[i].label;
                type = UserSettings.fields.cp.all[i].type;
              }
            }
            if (f == "order_no") {
              return { id: f, field: f, type: type, name: label, sortable: true, formatter: HPOrderNoFormatter }
            } else
              if (f == "product_line") {
                return { id: f, field: f, type: type, name: label, sortable: true }
              } else
                if (type == "date") {
                  return { id: f, field: f, type: type, name: label, formatter: DateFormatter }
                } else {
                  return { id: f, field: f, type: type, name: label}
                }
          });
        } else if (!this.props.subscreen || this.props.subscreen == 'header') {
          subscreen = 'header';

          if (this.props.dmfiPending && this.props.dmfiPending == "Y") {

            var drilldownColumns = [];

            drilldownColumns.push({ id: "purchase_order_no", field: "purchase_order_no", type: "string", name: "Purchase Order no", sortable: true });
            drilldownColumns.push({ id: "order_no", field: "order_no", type: "string", name: "Order No", sortable: true, formatter: HPOrderNoFormatter });
            drilldownColumns.push({ id: "po_date", field: "purch_order_date", type: "string", name: "PO Date", sortable: true, formatter: DateFormatter });
            drilldownColumns.push({ id: "end_customer", field: "end_cust_name", type: "string", name: "End Customer", sortable: true });
            drilldownColumns.push({ id: "end_customer_country", field: "end_customer_country", type: "string", name: "End Customer Country", sortable: true });
            drilldownColumns.push({ id: "ship_to", field: "ship_to_country", type: "string", name: "Ship to country", sortable: true });
            drilldownColumns.push({ id: "partner", field: "customer_name", type: "string", name: "Partner", sortable: true, maxWidth: 200 });
            drilldownColumns.push({ id: "stats", field: "order_overall_status", type: "string", name: "Status", sortable: true });
            drilldownColumns.push({ id: "workflow_status", field: "workflow_status", type: "string", name: "Workflow Status", sortable: true, maxWidth: 300, formatter: WorkflowFormatter });
            drilldownColumns.push({ id: "last_update", field: "last_update_date", type: "string", name: "Last Update", sortable: true, formatter: DateFormatter });
          }
          // GEGA Remove bucket condition when we finally clean up our Dataservices
          else if (this.props.type == "searchresult" && UserSettings.fields.order.orderLevelOutputmode == 'itemShow'
          ) {
            subscreen = 'item';
            var drilldownColumns = filterFieldsByAvailability(UserSettings.fields.item.choosen).map(function (f) {
              var label = f;
              for (var i = 0; i < UserSettings.fields.item.all.length; i++) {
                if (UserSettings.fields.item.all[i].field == f) {
                  label = UserSettings.fields.item.all[i].label;
                  type = UserSettings.fields.item.all[i].type;
                }
              }
              if (f == "order_no") {
                return { id: f, field: f, type: type, name: label, sortable: true, formatter: HPOrderNoFormatter }
              } else
                if (f == "invoice_no" && state.withPrices != "N") {
                  return { id: f, field: f, type: type, name: label, sortable: true, formatter: InvoiceNoFormatter }
                } else
                  if (type == "date") {
                    return { id: f, field: f, type: type, name: label, sortable: true, formatter: DateFormatter }
                  } else
                    if (type == "amount") {
                      return { id: f, field: f, type: type, name: label, sortable: true, formatter: AmountFormatter }
                    } else
                      if (f == "product_no") {
                        return { id: f, field: f, type: type, name: label, sortable: true, formatter: ESDFormatter }
                      } else
                        if (f == "order_overall_status" || f == "status") {
                          return { id: f, field: f, type: type, name: label, sortable: true, formatter: ItemStatusFormatter }
                        } else {
                          return { id: f, field: f, type: type, name: label, sortable: true }
                        }
            });

          } else {

            var drilldownColumns = filterFieldsByAvailability(UserSettings.fields.order.choosen).map(function (f) {
              var label = f;
              for (var i = 0; i < UserSettings.fields.order.all.length; i++) {
                if (UserSettings.fields.order.all[i].field == f) {
                  label = UserSettings.fields.order.all[i].label;
                  type = UserSettings.fields.order.all[i].type;
                }
              }
              if (f == "order_no") {
                return { id: f, field: f, type: type, name: label, sortable: true, formatter: HPOrderNoFormatter }
              } else
                if (f == "invoice_no" && state.withPrices != "N") {
                  return { id: f, field: f, type: type, name: label, sortable: true, formatter: InvoiceNoFormatter }
                } else
                  if (type == "date") {
                    return { id: f, field: f, type: type, name: label, sortable: true, formatter: DateFormatter }
                  } else
                    if (type == "amount") {
                      return { id: f, field: f, type: type, name: label, sortable: true, formatter: AmountFormatter }
                    } else
                      if (f == "order_overall_status" || f == "status") {
                        return { id: f, field: f, type: type, name: label, sortable: true, formatter: ItemStatusFormatter }
                      } else {
                        return { id: f, field: f, type: type, name: label, sortable: true }
                      }
            });
          }
        } else {
          subscreen = 'detail';
          var drilldownColumns = filterFieldsByAvailability(UserSettings.fields.mfg.choosen).map(function (f) {
            var label = f;
            for (var i = 0; i < UserSettings.fields.mfg.all.length; i++) {
              if (UserSettings.fields.mfg.all[i].field == f) {
                label = UserSettings.fields.mfg.all[i].label;
                type = UserSettings.fields.mfg.all[i].type;
              }
            }
            if (f == "order_no") {
              return { id: f, field: f, type: type, name: label, sortable: true, formatter: HPOrderNoFormatter }
            } else
              if (f == "invoice_no" && state.withPrices != "N") {
                return { id: f, field: f, type: type, name: label, sortable: true, formatter: InvoiceNoFormatter }
              } else
                if (type == "date") {
                  return { id: f, field: f, type: type, name: label, sortable: true, formatter: DateFormatter }
                } else
                  if (type == "amount") {
                    return { id: f, field: f, type: type, name: label, sortable: true, formatter: AmountFormatter }
                  } else
                    if (f == "order_overall_status" || f == "status") {
                      return { id: f, field: f, type: type, name: label, sortable: true, formatter: ItemStatusFormatter }
                    } else {
                      return { id: f, field: f, type: type, name: label, sortable: true }
                    }
          });
        }

        //CR 17654 - Add two additional cols for DMFI Tab
        if (this.props.dmfiPending && this.props.dmfiPending == "S") {
          drilldownColumns.push({ id: "endcust_planned_delivery_date", field: "endcust_planned_delivery_date", type: "string", name: "End Customer Planned Delivery Date", sortable: true, minWidth: 100, formatter: DateFormatter });
          drilldownColumns.push({ id: "endcust_delivery_date", field: "endcust_delivery_date", type: "string", name: "End Customer Delivery Date", sortable: true, formatter: DateFormatter });
        }

        console.log('drilldownColumns=', drilldownColumns);


        var drilldownHeight = 480;
        if (window.outerHeight) {
          drilldownHeight = window.outerHeight - 550;
        }
        if (drilldownHeight < 300) {
          drilldownHeight = 300;
        }
        var drilldownPanelStyle = {
          height: drilldownHeight + 'px',
          margin: '0px',
          'marginLeft': '-1px',
          padding: '0px'
        }

        if (this.props.hideGrid) {
          var grid = <div>
            Loading ...
          </div>;
        } else {
          console.log('before RDataGrid  order=', order);
          if (order == null) {
            var grid = <RDataGrid id={'drilldowndata'} columns={drilldownColumns}
              nrOfRealRows={0} data={[]} embedInto="#drilldownPanel" subscreen={subscreen} exportToExcel={exportToExcel} dmfiPending={this.props.dmfiPending ? this.props.dmfiPending : ""} />
          } else {
            var grid = <RDataGrid id={'drilldowndata'} columns={drilldownColumns}
              onClick={this.handleRowClick}
              nrOfRealRows={order.length} data={order} embedInto="#drilldownPanel" subscreen={subscreen} exportToExcel={exportToExcel} dmfiPending={this.props.dmfiPending ? this.props.dmfiPending : ""} />
          }
        }

        displayTable = (
          <div style={{marginTop:"10px"}}>
            <div id='drilldownPanel' style={drilldownPanelStyle} >
              {grid}
            </div>
          </div>
        )
      }


      var type = "preDefTemplate";
      var header = "";
      var header1 = "";
      var exportURL = "";
      if (this.props.type == "searchresult") {
        exportURL = RewriteRESTURL("/os/ossui/v1/ex/externalDrilldownForExportTitanium/searchresult/total/1/" + I18N.locale);
      } else if (this.props.searchQry.bucket == "All Bucket" && this.props.searchQry.range == "ALL") {
        exportURL = RewriteRESTURL("/os/ossui/v1/ex/externalDrilldownForExportTitanium/submittedOrders/total/1/" + I18N.locale);
      } else if (this.props.searchQry.bucket == "lastOrdersViewed" || this.props.searchQry.bucket == "lastOrdersPlaced" || this.props.searchQry.bucket == "lastOrdersShipped") {
        exportURL = RewriteRESTURL("/os/ossui/v1/ex/externalDrilldownLastOrdersForExport/" + this.props.searchQry.bucket + "/0/" + I18N.locale);
      } else {
        exportURL = RewriteRESTURL("/os/ossui/v1/ex/externalDrilldownForExportTitanium/H/" + this.props.searchQry.bucket + "/" + this.props.searchQry.range + "/0/" + I18N.locale);
      }

      var multipleOrderMsg = "";

      if (this.props.type != "dashboard") {
        multipleOrderMsg = (
          <div className="col-md-12 bottompadding5" >
            <div id="drillDownHeader" style={{ "background": "#f5f5f5", "minWidth": "30px", "padding": "3px 3px 3px 6px", "textAlign": "left", "border": "1px solid #ccc" }}>
              <div className="btn-group">
                {T('Multiple orders found - Please select:')}
              </div>
            </div>
          </div>
        )
      }

      if (this.props.type == "dashboard") {

        var bucketText = this.props.searchQry.bucket;
        var rangeText = this.props.searchQry.range;

        if (rangeText == "total") { rangeText = "Last 100 days" }

        header = (
          <td style={{ "color": "#ffffff", "textAlign": "center", "word-spacing": "2px", "padding": "5px 5px 1px 1px" }}>
            <label className="control-label">{T('{bucketText}')} &nbsp;{T('order_bucket')} </label>
            <label className="control-label">&nbsp;-&nbsp;</label>
            <label className="control-label">{T('Ordering Period')} :</label>&nbsp;{T('{rangeText}')}
          </td>
        )
        header = ""

      } else {
        var searchText = "";

        if (this.props.searchQry.id && this.props.searchQry.id != "" && this.props.searchQry.searchField && this.props.searchQry.searchField != "") {
          searchText = (
            <div style={{ "color": "#ffffff" }}>
              <label className="control-label">{T('searchField')} :&nbsp;</label>
              {this.props.searchQry.searchField}
              &nbsp; &nbsp;
              <label className="control-label">{T('searchID')} :&nbsp;</label>
              {this.props.searchQry.id}
            </div>
          )
        }
        if (dataRangeStr && dataRangeStr != "" && this.props.searchQry.id && this.props.searchQry.id != "") {
          searchText = (
            <div style={{ "color": "#ffffff" }}>
              <label className="control-label">{T('searchField')} :&nbsp;</label>
              {this.props.searchQry.searchField}
              &nbsp; &nbsp;
              <label className="control-label">{T('searchID')} :&nbsp;</label>
              {this.props.searchQry.id}
              &nbsp; &nbsp;
              <label className="control-label">{T('and')} &nbsp;</label>
              {dataRangeStr}
            </div>
          )
        } else if (dataRangeStr && dataRangeStr != "") {
          searchText = (
            <div>
              <label className="control-label">{T('searchID')} :&nbsp;</label>
              {dataRangeStr}
            </div>
          )
        }

        header = (
          <span style={{ "color": "#ffffff", "textAlign": "left" }}>
            {searchText}
          </span>
        )
      }

      var backButton = null;

      if (this.props.type != "default") {
        backButton = (<button type="button" id="backButton" className="btn btn-primary btn-sm" onClick={this.handleBack}>{T('Back')} </button>);
        $("#orderSelectList").show();
        $("#exportToExcel").show();
        $("#backButton").show();
      }

      var preSearchLons = [];
      if (this.props.hasOwnProperty("order") && this.props.order.hasOwnProperty("data") && Array.isArray(this.props.order.data.lons)) {
        preSearchLons = this.props.order.data.lons;
      }

      // Hide Carepack Tab by default
      var featureToggle = {'display' :'none'};

      // Only show Carepack Tab for specific users or profiles
      if (window.UserSettings.featureToggles.includes("cp_dashboard")) {
        var featureToggle = {'display' :'inline'};
      }

      return (
        <div>
          <div id="resultMsg"></div>
          <TabBarNew onTabChange={this.handleTabChange}>
            <div label={T('Order Search')} name="headerSearchTab">
              <div id="resultMsg"></div>
              <OSWidgetSearchWrapper tabIndicator="H" searchQry={searchQry} showOrder={showOrder} />
            </div>
            <div label={T('Manufacturing Data Search')} name="detailSearchTab">
              <div id="resultMsg"></div>
              <OSWidgetSearchWrapper tabIndicator="D" searchQry={searchQry} showOrder={showOrder} />
            </div>
            <div label={T('Services')} style={featureToggle} name="carepackDashboard">
              <div id="resultMsg"></div>
                <OSWidgetSearchWrapper tabIndicator="CP" searchQry={searchQry} showOrder={showOrder} />
            </div>
          </TabBarNew>
          <div id='multipleOrdersLandingPage' style={{ 'width': '100%', 'paddingTop':'15px' }}>
            {this.state.activeTab != 2 && <MyLastOrders />}
            {this.state.activeTab == 2 && <CarepackDashboard preSearchLons={preSearchLons}/>}
            {displayTable}
            <hr style={{ height: '0px', 'borderTop': '1px solid #ffffff', 'margin': '2px' }} />
            <br />
            {backButton}
          </div>
        </div>
      )

    } else {

      $('#headernav ul.nav li').removeClass('active');
      $('#headernav ul.nav li.notification').addClass('active');
      let data = this.state.notifications;
      let status = this.state.status;

      if (status === 'S' || status === 'N') {
        return (
          <Notifications data={data} />
        )
      } else {
        return (
          <BasicAlert type={status} />
        )
      }

    }
  }

};
